/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { APP_VERSION, AV, AV_EMPTY, BIO_MAX, BLANK_PNG, BROADCAST_AV, BUZZ_H, CHAT_W, COMMENT_MAX_CHARS, TASKBAR_H, Z_LAAG, Z_VENSTER, TOOL_COL_W, EMOJIS, GB_EMPTY, GB_GRID_URL, GB_PER_DAY, GH, GW, LEGACY_AUTHOR_IDS, MAINTAINER_ID, MAX_FRAMES, ONLINE_MS, POLE_BG, PULL_TRIGGER } from '../lib/config.js';
import { NOTE_H, NOTE_W, poleWidth } from '../lib/board.js';
import { cellsToPath, cubeCells, isoCells } from '../lib/guides.js';
import { iconStroke } from '../lib/icons.js';
import { PALETTE_HEX } from '../lib/palette.js';
import * as tam from '../lib/tamagotchi.js';
import { DEFAULT_AV, avatarUrl, pixUrl } from '../lib/pixels.js';
import { BUZZ_CLIP, isBuzzText } from '../lib/sound.js';
import { animDur, byName, dayKey, isSingleEmoji, mentionSplit, nextDayKey, parseTs, relTime, roughTime, stampTime, withMedals } from '../lib/text.js';
import * as store from '../lib/store.js';

export default {
  renderVals() {
      const mob = this.state.isMobile;
      // Zie accModalStyle: de naamlijst hangt in de rechterbovenhoek, het formulier
      // en een profiel staan in het midden. Dit volgt uit wát er te zien is en niet
      // meer uit een vlag die zegt hoe je binnenkwam. Die vlag stond alleen aan als
      // openAccount langsgekomen was, en er lopen drie routes rechtstreeks naar
      // dialog 'account': openProfile, closeProfile en notifGoProfile. Kwam je zo
      // binnen en klikte je daarna op Profielen, dan viel de naamlijst terug in het
      // oude venster van 640 met een donkere laag over de paal.
      const halHoek = !this.state.accEdit && !this.state.profileId;
      const mq = (a, b) => (mob ? a : b);
      // Smalle desktop: kleinere knoppen in de balk, zodat ze de tabs nooit raken.
      const hbW = !mob && this.state.narrowHeader ? '38px' : '46px';
      const hbR = !mob && this.state.narrowHeader ? '13px' : '16px';
      const hdrBtn = { position: 'relative', flex: '0 0 auto', height: hbW, width: hbW, borderRadius: hbR, padding: '0', justifyContent: 'center' };
      const mentions = this.mentionMatches();
      const connected = this.state.connected;
      // Elk vakje in de avatar-tekenaar is vierkant: de kleuren, het gereedschap en
      // opnieuw. Niet met een vaste hoogte maar met een verhouding, zodat ze meegroeien
      // met de kolombreedte die het raster van zes ze geeft. Een vaste hoogte kon niet
      // toen "Opnieuw" nog een woord was; nu alle twaalf een tekentje of een kleur zijn,
      // kan het wel.
      const AV_VAK = { aspectRatio: '1 / 1' };
      const px = this.state.canvasPx;
      // Alleen berichten van anderen; zie unreadFromOthers in logic/chat.js.
      const myAvatar = this.state.avatar && this.state.avatar.length === AV * AV
        ? this.state.avatar
        // Nog geen account? Dan telt het avatartje dat je alvast getekend hebt.
        : (!this.state.accountId ? ((() => { try { const d = store.get('gp_avatar_draft'); return d && d.length === AV * AV ? d : ''; } catch (e) { return ''; } })()) : '');
      const editAvatar = this.state.editAvatar || AV_EMPTY;
      const now = Date.now();
      const myAccount = this.state.accounts.find((a) => a.id === this.state.accountId) || {};
      const myPinSet = !!myAccount.pinHash;
      const onlineUsers = this.state.accounts.filter((a) => {
        const t = Date.parse(a.lastSeen || '');
        return a.id === this.state.accountId || (!isNaN(t) && now - t < ONLINE_MS);
      });
      const onlineCount = onlineUsers.length;
      // Jij vooraan, en op een smalle kop passen er minder naast elkaar.
      const gezichtMax = mob ? 4 : this.state.narrowHeader ? 5 : 8;
      const onlineAvatars = onlineUsers.slice().sort((x, y) => (x.id === this.state.accountId ? -1 : 0) - (y.id === this.state.accountId ? -1 : 0)).slice(0, gezichtMax);
      const showFaces = onlineCount > 0;
      // Wie de krabbel van de dag is, staat in logic/gallery.js: die som stond hier
      // en het pictogram op het bureaublad kon er niet bij.
      /**
       * Hoe breed het vel van het gastenboek is, en daarmee alles eronder.
       *
       * Vierkant en passend in de hoogte, zodat het venster nooit scrolt. Op een
       * computer krimpt de kleurenrij mee (zie gbRijStyle); op de telefoon loopt hij
       * door op een tweede regel, want daar zijn de vakjes anders te klein voor een
       * vinger.
       */
      const gbMaat = 'max(150px, min(100%, calc(90vh - ' + (mob ? 250 : 275) + 'px)))';
      // Een knop in de kleurenrij: vaste maat op de telefoon, op een computer een
      // tiende van het vel.
      const gbVakje = mob
        ? { width: '38px', height: '38px' }
        : { width: '100%', height: 'auto', aspectRatio: '1 / 1', minWidth: '0' };
      const { dagStart: dayStart, rij: dailySorted } = this.dagPot();
      const { gekozen: pickedDaily, zelf: autoDaily } = this.dagKeuze();
      const daily = pickedDaily || autoDaily;
      // De mod kiest voor morgen: keuzes en index schuiven een dag op. Wat de paal
      // morgen zelf kiest rekent met de pot van morgen, en daar zit alles van vandaag
      // in. Met de pot van vandaag klopte de voorspelling zodra er vandaag iets
      // geplakt was. Hij geldt dus als er vandaag niets meer bijkomt.
      const morgen = this.dagPot(dayStart.getTime() + 86400000 + 3600000);
      const autoNext = morgen.rij.length
        ? morgen.rij[Math.floor(morgen.dagStart.getTime() / 86400000) % morgen.rij.length] : null;
      const nextRec = this.state.dailyNext && this.state.dailyNext.day === nextDayKey() ? this.state.dailyNext : null;
      const nextPickedId = nextRec ? nextRec.drawingId : '';
      const nextPicked = nextPickedId ? this.state.galleryItems.find((g) => g.id === nextPickedId) : null;
      // Wat al eens de krabbel van de dag was, doet niet meer mee — behalve de keuze voor morgen zelf.
      const usedDaily = {};
      (this.state.dailyUsed || []).forEach((id) => { if (id && id !== nextPickedId) usedDaily[id] = 1; });
      const unusedDaily = dailySorted.filter((g) => !usedDaily[g.id]);
      const choicePool = unusedDaily.length ? unusedDaily : dailySorted;
      // De drie voorstellen liggen ver uit elkaar in de lijst, zodat ze per dag echt doorschuiven.
      const choiceStep = Math.max(1, Math.floor(choicePool.length / 3));
      const choiceIdx = choicePool.length ? Math.floor((dayStart.getTime() + 86400000) / 86400000) % choicePool.length : 0;
      const dailyChoices = choicePool.length
        ? [0, 1, 2].map((k) => choicePool[(choiceIdx + k * choiceStep) % choicePool.length]).filter((g, i, arr) => g && arr.indexOf(g) === i)
        : [];
      if (nextPicked && dailyChoices.indexOf(nextPicked) === -1) dailyChoices.unshift(nextPicked);
      const accountById = {};
      this.state.accounts.forEach((a) => { accountById[a.id] = a; });
      const duoPartner = this.state.duo ? accountById[this.duoPartnerId()] : null;
      const duoInviter = this.state.duoInvite ? accountById[this.state.duoInvite.aId] : null;
      const reqAll = (this.state.reqList || []);
      const reqByDrawing = {};
      reqAll.forEach((r) => { if (r.status === 'done' && r.drawingId) reqByDrawing[r.drawingId] = r; });
      const isOpenReq = (r) => !r.status || r.status === 'open';
      const openForMe = reqAll.filter((r) => isOpenReq(r) && r.fromId !== this.state.accountId && (!r.toId || r.toId === this.state.accountId));
      const reqVisible = reqAll.filter((r) => !r.toId || r.toId === this.state.accountId || r.fromId === this.state.accountId)
        .filter((r) => r.status !== 'cancelled' && !r.archived)
        .slice().sort((x, y) => (isOpenReq(x) ? 0 : 1) - (isOpenReq(y) ? 0 : 1) || (parseTs(y.created) - parseTs(x.created)));
      const isWide = (g) => !!(g && (g.coAuthorId || this.state.wideIds[g.id]));
      // Waar hangt welke krabbel aan de paal. Eén keer per hertekening, niet per
      // krabbel: de plek van de een volgt uit die van de ander. Zie lib/board.js.
      const wall = this.wallLayout(this.state.galleryItems, isWide);
      const aantalKrabbels = this.state.galleryItems.length;
      const dmCur = (this.state.dmInbox || [])[0] || null;
      const nameToId = {};
      this.state.accounts.forEach((a) => { nameToId[a.name] = a.id; });
      // One resolver for every author-ish record: accountId wins, name is only a legacy fallback.
      const accOf = (o) => {
        if (!o) return null;
        const id = o.accountId || o.authorId || o.id || '';
        return accountById[id] || accountById[nameToId[o.author || o.name || o.n] || ''] || null;
      };
      const nameOf = (o) => { const a = accOf(o); return a ? a.name : (o ? (o.author || o.n || '') : ''); };
      const keyOf = (g) => { const a = accOf(g); return a ? 'id:' + a.id : 'name:' + (g.author || g.n || ''); };
      const accByKey = (k) => accountById[String(k).replace(/^id:/, '')] || null;
      const daysByAuthor = {};
      const todayKey = new Date().toDateString();
      const todayKeys = [];
      const nameByKey = {};
      this.state.galleryItems.forEach((g) => {
        const t = parseTs(g.created);
        if (isNaN(t)) return;
        const gkey = keyOf(g);
        const key = new Date(t).toDateString();
        if (!nameByKey[gkey]) nameByKey[gkey] = nameOf(g) || g.author;
        (daysByAuthor[gkey] = daysByAuthor[gkey] || {})[key] = true;
        if (key === todayKey && todayKeys.indexOf(gkey) === -1) todayKeys.push(gkey);
      });
      // Weekend bevriest de streak: zaterdag/zondag tellen niet mee en breken 'm ook niet.
      const isWeekendDay = (d) => { const g = d.getDay(); return g === 0 || g === 6; };
      const skipWeekend = (d) => { while (isWeekendDay(d)) d.setDate(d.getDate() - 1); };
      const streakOfKey = (key) => {
        const days = daysByAuthor[key];
        if (!days) return 0;
        let n = 0;
        const probe = new Date(); probe.setHours(0, 0, 0, 0);
        if (!isWeekendDay(probe) && !days[probe.toDateString()]) probe.setDate(probe.getDate() - 1);
        skipWeekend(probe);
        while (days[probe.toDateString()]) {
          n++;
          probe.setDate(probe.getDate() - 1);
          skipWeekend(probe);
        }
        return n;
      };
      const streakOf = (nameOrAcc) => {
        const acc = typeof nameOrAcc === 'string' ? accountById[nameToId[nameOrAcc] || ''] : nameOrAcc;
        return streakOfKey(acc ? 'id:' + acc.id : 'name:' + nameOrAcc);
      };
      const todayUsers = todayKeys.map((k) => {
        const acc = accByKey(k);
        return { id: acc ? acc.id : '', name: acc ? acc.name : (nameByKey[k] || ''), avatar: acc ? acc.avatar : '', streak: streakOfKey(k) };
      });
      const lastDrawingTs = {};
      this.state.galleryItems.forEach((g) => {
        const t = parseTs(g.created);
        const k = keyOf(g);
        if (!isNaN(t) && (!lastDrawingTs[k] || t > lastDrawingTs[k])) lastDrawingTs[k] = t;
      });
      /**
       * De meldingen alleen opbouwen als de bel open staat.
       *
       * Dit is de duurste lijst in renderVals: alle accounts, krabbels, verzoekjes,
       * reacties, hartjes, ideetjes en beestjes, gesorteerd en met een stijl per kaart.
       * renderVals loopt bij elke hover opnieuw, en de lijst stond alleen in de bel.
       */
      const belOpen = !!this.state.notifOpen;
      const likeNotifs = !belOpen ? [] : this.state.galleryItems.reduce((acc, g) => {
        g.likedBy.forEach((l) => {
          if (!l.t) return;
          const a = accOf({ accountId: l.id, name: l.n });
          acc.push({
            ts: l.t, icon: '\u2764\ufe0f', avatarUrl: avatarUrl(a ? a.avatar : ''),
            text: (a ? a.name : (l.n || 'iemand')) + ' vond "' + g.title + '" leuk', when: relTime(new Date(l.t).toISOString()),
            title: 'Bekijk "' + g.title + '"', onClick: () => this.notifGoDrawing(g.id)
          });
        });
        return acc;
      }, []);
      const notifFeed = !belOpen ? [] : []
        .concat(this.state.accounts.map((a) => ({
          ts: parseTs(a.created), icon: '🪪', avatarUrl: avatarUrl(a.avatar), big: true,
          text: a.name + ' maakte een account', when: relTime(a.created),
          title: 'Bekijk het profiel van ' + a.name, onClick: () => this.notifGoProfile(a.id)
        })))
        .concat(this.state.galleryItems.map((g) => ({
          ts: parseTs(g.created), icon: '🎨', avatarUrl: g.src, big: true,
          text: nameOf(g) + ' maakte "' + g.title + '"', when: relTime(g.created),
          title: 'Bekijk "' + g.title + '"', onClick: () => this.notifGoDrawing(g.id)
        })))
        /**
         * Alle verzoekjes, ook die aan één persoon gericht zijn. Dat is een keuze en geen
         * vergissing (8 oktober 2026): "A vroeg B om een krabbel" is nieuws voor de hele
         * paal. Filter dit dus niet zoals `reqVisible`, die is voor het postvakje.
         */
        .concat(reqAll.map((r) => {
          const f = accountById[r.fromId];
          const t = r.toId ? accountById[r.toId] : null;
          const fn = f ? f.name : 'iemand';
          const tn = t ? t.name : 'iedereen';
          return {
            ts: parseTs(r.created),
            icon: r.status === 'done' ? '✅' : (r.status === 'declined' ? '🙈' : (r.status === 'cancelled' ? '🗑️' : '✉️')),
            avatarUrl: avatarUrl(f ? f.avatar : ''),
            text: r.status === 'done'
              ? tn + ' tekende het verzoekje van ' + fn
              : (r.status === 'declined'
                ? tn + ' kon het verzoekje van ' + fn + ' niet tekenen'
                : (r.status === 'cancelled'
                  ? fn + ' trok het verzoekje aan ' + tn + ' weer in'
                  : fn + ' vroeg ' + tn + ' om een krabbel')),
            when: relTime(r.created),
            title: 'Naar je postvakje', onClick: this.openInbox
          };
        }))
        .concat((() => {
          const byId = {};
          this.state.galleryItems.forEach((g) => { byId[g.id] = g; });
          const out = [];
          Object.keys(this.state.comments || {}).forEach((did) => {
            const g = byId[did];
            if (!g) return;
            const onMine = this.isMine(g);
            (this.state.comments[did] || []).forEach((c) => {
              const acc = accountById[c.accountId];
              const mine = (c.accountId && c.accountId === this.state.accountId) || (!c.accountId && c.author === this.state.author);
              if (mine) return;
              out.push({
                ts: parseTs(c.created), icon: '💬', avatarUrl: avatarUrl(acc ? acc.avatar : ''),
                big: onMine,
                text: c.author + (onMine ? ' reageerde op jouw "' + g.title + '"' : ' reageerde op "' + g.title + '"') + ': ' + c.text,
                when: relTime(c.created),
                title: 'Bekijk "' + g.title + '"', onClick: () => this.notifGoDrawing(g.id)
              });
            });
          });
          return out;
        })())
        .concat(likeNotifs)
        .concat((this.state.featureList || []).filter((f) => f.solved && !f.declined).map((f) => {
          const acc = accOf({ accountId: f.authorId || LEGACY_AUTHOR_IDS[f.author], author: f.author });
          const mine = !!(f.authorId && f.authorId === this.state.accountId);
          return {
            ts: parseTs(f.updated || f.created), icon: '🛠️', avatarUrl: avatarUrl(acc ? acc.avatar : ''),
            big: mine,
            text: (mine ? 'Jouw ideetje is doorgevoerd' : 'Het ideetje van ' + ((acc && acc.name) || f.author || 'iemand') + ' is doorgevoerd') + ': ' + f.text,
            when: relTime(f.updated || f.created),
            title: 'Naar de ideeënbus', onClick: this.requestFeature
          };
        }))
        /**
         * Wie wie te eten gaf.
         *
         * Dit stond in het Krabbelgotchi-venster zelf, als groene regel onder de
         * leeftijd. Daar was het op de verkeerde plek: het is nieuws, en nieuws hoort
         * bij de bel, waar je het ook ziet als je het spel niet openhebt. In dat
         * schermpje bleef het bovendien staan tot de volgende keer dat iemand hem
         * voerde, dus na een dag las je nog steeds wat er gisteren gebeurde.
         *
         * Eén beperking, en die zit in de server: op de regel van een beestje staat
         * alleen wie hem als *laatste* voerde (`gevoerdDoor`) en wanneer hij als
         * laatste at (`gevoed`). Er is dus één melding per beestje en niet één per
         * keer. Wil je de hele geschiedenis, dan is er een tafel met voerbeurten
         * nodig; dat is een serverwijziging en die staat hier niet.
         *
         * Jezelf voeren levert geen melding op: dat weet je.
         */
        .concat((this.state.tamRijen || []).map((r) => {
          const wie = r.gevoerdDoor;
          if (!wie || wie === r.authorId || wie === this.state.accountId) return null;
          const ts = Number(r.gevoed) || 0;
          // Iedereen mag in deze regels schrijven, en een tijdstip dat geen datum kan
          // zijn laat toISOString gooien. Dan viel renderVals om, bij iedereen.
          if (!Number.isFinite(ts) || ts <= 0 || ts > Date.now() + 864e5) return null;
          const gever = accountById[wie];
          const eigenaar = accountById[r.authorId];
          const naam = tam.naamOk(r.naam);
          const mijn = r.authorId === this.state.accountId;
          const beestje = naam || 'het beestje';
          return {
            ts, icon: '🍴', avatarUrl: avatarUrl(gever ? gever.avatar : ''),
            // Dikgedrukt als het over jouw beestje gaat, net als bij een reactie op
            // je eigen krabbel: dan is het aan jou gericht en niet alleen nieuws.
            big: mijn,
            text: ((gever && gever.name) || 'Iemand') + ' gaf '
              + (mijn ? beestje + ' te eten' : beestje + ' van ' + ((eigenaar && eigenaar.name) || 'iemand') + ' te eten'),
            when: relTime(new Date(ts).toISOString()),
            title: 'Naar de Krabbelgotchi', onClick: this.openTamagotchi
          };
        }).filter(Boolean))
        .concat(this.state.accounts.filter((a) => streakOf(a.name) >= 2).map((a) => ({
          ts: lastDrawingTs['id:' + a.id] || 0, icon: '🔥', avatarUrl: avatarUrl(a.avatar),
          text: a.name + ' krabbelt ' + streakOf(a.name) + (streakOf(a.name) === 1 ? ' dag' : ' dagen') + ' op rij', when: relTime(new Date(lastDrawingTs['id:' + a.id] || Date.now()).toISOString()),
          title: 'Bekijk het profiel van ' + a.name, onClick: () => this.notifGoProfile(a.id)
        })))
        .filter((n) => !isNaN(n.ts) && n.ts > 0)
        .sort((a, b) => b.ts - a.ts)
        .slice(0, 80)
        .map((n) => Object.assign({}, n, {
          // Twee regels in plaats van één afgekapte: -webkit-line-clamp knipt pas
          // na de tweede regel, en dan lees je wel waar het over gaat.
          textStyle: {
            display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, overflow: 'hidden',
            fontWeight: n.big ? 700 : 500, color: n.big ? 'var(--ink)' : 'var(--tekst-2)',
            lineHeight: 1.25
          },
          // Ongelezen valt op met lila, gelezen is wit. Zo hoeft de emoji niet de
          // enige aanwijzing te zijn dat er iets nieuw is.
          rijStyle: {
            display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px',
            width: '100%', boxSizing: 'border-box', textAlign: 'left', fontFamily: 'inherit',
            color: 'var(--ink)', cursor: 'pointer', padding: '6px 9px', borderRadius: '12px',
            border: '2px solid var(--ink)', background: n.big ? 'var(--lila)' : '#fff',
            // Elke kaart even hoog: dat is de hoogste, en dat is er een met twee
            // regels tekst plus de tijd eronder. Twee keer 17 tekst, 13 tijd, 12
            // binnenruimte en 4 rand. Met alles in het midden hangt een bericht van
            // één regel netjes gecentreerd in plaats van met een gat onder de
            // tekst, en staat een rij kaarten op één ritme.
            height: '63px', flex: '0 0 auto'
          }
        }));
      const notifLimit = this.state.notifLimit || 15;
      const notifShown = notifFeed.slice(0, notifLimit);
      const likerChips = (item) => (item ? item.likedBy : []).slice().sort((a, b) => (b.t || 0) - (a.t || 0)).map((l) => {
        const acc = accOf({ accountId: l.id, name: l.n });
        const name = acc ? acc.name : (l.n || 'iemand');
        const isMe = (l.id && l.id === this.state.accountId) || (!l.id && l.n === this.state.author);
        return {
          name: isMe ? 'jij' : name,
          when: l.t ? relTime(new Date(l.t).toISOString()) : '',
          avatarUrl: avatarUrl(acc ? acc.avatar : '')
        };
      });
      const viewer = this.state.viewerId ? this.state.galleryItems.find((it) => it.id === this.state.viewerId) : null;
      // De maat van de tekening in de viewer, en daarmee de breedte van het venster.
      // In pixels uitgerekend en niet als css-min(), want het venster moet dezelfde maat
      // weten. Dezelfde grenzen als voorheen: 56% van de schermhoogte en hoogstens 420
      // voor een gewone krabbel, 84% van de breedte en hoogstens 760 voor een brede.
      const vwNu = typeof window !== 'undefined' ? window.innerWidth : 1200;
      const vhNu = typeof window !== 'undefined' ? window.innerHeight : 800;
      const viewerZijde = Math.round(Math.min(0.56 * vhNu, 420));
      const viewerTekening = viewer && isWide(viewer) ? Math.round(Math.min(0.84 * vwNu, 760)) : viewerZijde;
      // Plus 24 padding aan elke kant en de rand van 4; nooit breder dan het scherm.
      const viewerBreed = Math.min(viewerTekening + 2 * 24 + 8, vwNu - 24);
      const viewerRequestedFlag = !!(viewer && reqByDrawing[viewer.id]);
      const viewerThemaFlag = !!(viewer && viewer.isThemeMatch);
      const viewerLikers = likerChips(viewer);
      const anonLikes = viewer ? Math.max(0, viewer.likesCount - viewerLikers.length) : 0;
      const avatarByName = {};
      this.state.accounts.forEach((a) => { avatarByName[a.name] = a.avatar; });
  
      // Ongedaan maken en opnieuw: dezelfde maat als de gereedschappen erboven. Ze
      // rekten mee met de kolom, en toen de gereedschappen een bovengrens kregen
      // aten deze twee de overgebleven ruimte op en werden ze dubbel zo hoog.
      const histBtn = {
        flex: '0 0 auto', height: this.toolMetrics().size + 'px', width: this.toolMetrics().size + 'px', alignSelf: 'center',
        boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: '12px', border: '3px solid var(--ink)', cursor: 'pointer', background: '#fff', color: 'var(--ink)'
      };
  
      return {
        // Via de knop rechtsboven land je altijd in de hal, ook zonder account.
        openAccount: this.openIedereen,
        undo: this.undo,
        redo: this.redo,
        noUndo: this.state.undoN === 0,
        noRedo: this.state.redoN === 0,
        undoStyle: Object.assign({}, histBtn, this.state.undoN === 0 ? null : this.pressFx('undo')),
        redoStyle: Object.assign({}, histBtn, this.state.redoN === 0 ? null : this.pressFx('redo')),
        // Alleen het cijfer: "Iedereen hier" staat er als titel al boven, en twee
        // keer hetzelfde naast elkaar leest als een fout.
        hasToast: !!this.state.toast,
        hasToastAvatar: !!this.state.toastAvatar,
        noToastAvatar: !this.state.toastAvatar,
        toastAvatar: this.state.toastAvatar,
        toast: this.state.toast,
        hideToast: () => { clearTimeout(this.toastTimer); this.setState({ toast: '', toastAvatar: '' }); },
        todayUsers: todayUsers.map((t) => ({
          avatarUrl: avatarUrl(t.avatar),
          title: t.id
            ? 'Bekijk ' + t.name + (t.streak >= 2 ? ' (' + t.streak + ' dagen op rij)' : '')
            : (t.streak >= 2 ? t.name + ' (' + t.streak + ' dagen op rij)' : t.name + ' krabbelde vandaag'),
          onOpen: t.id ? () => this.openAccount(undefined, t.id) : () => {}
        })),
        hasConfetti: this.state.confetti.length > 0,
        confetti: this.state.confetti.map((c) => ({
          style: {
            position: 'absolute', top: '0', left: c.left + '%', width: c.w + 'px', height: c.h + 'px',
            background: c.color, borderRadius: '2px', border: '2px solid var(--ink)',
            animation: 'confettiFall ' + c.dur + 's ' + c.delay + 's linear forwards'
          }
        })),
        dailyTitle: daily ? daily.title : '',
        openDaily: this.openDaily,
        // Niet alleen "er is een krabbel gekozen" maar ook "hij is niet weggeklapt".
        // Dat tweede stond hier niet, en toen deed de wegklapknop niets: de vlag ging
        // om en het venster bleef staan. Zie vensterLijst in logic/venster.js, dat is
        // de enige plek die weet of een venster in beeld hoort te staan.
        showViewer: !!viewer && this.vensterInfo('viewer').open,
        /**
         * Het venster is zo breed als de tekening, plus zijn padding.
         *
         * Het was 560 breed met een tekening van hoogstens 420 in het midden, en dan
         * sprong de tekening 42 pixels in ten opzichte van de titel en het hartje
         * eronder, die de volle breedte pakten. Nu is de kolom precies de tekening, en
         * lijnt alles op dezelfde twee randen uit. Een brede krabbel maakt het venster
         * breder in plaats van eruit te lopen: `min(84vw,760px)` in een kolom van 504
         * gaf een scrollbalk.
         */
        /**
         * Een krabbel bekijken is ook een venster geworden.
         *
         * Hij was een schermvullende laag die over alles heen ging, ook over de
         * taakbalk. Nu kun je hem naast je doek laten staan en er nog een openen; de
         * titelbalk draagt de naam van de krabbel, dus je ziet in de taakbalk waar je
         * naar kijkt. Op de telefoon vult hij het beeld zoals hij dat deed.
         */
        viewerVenster: this.vensterVals('viewer', mob ? '100%' : viewerBreed + 'px',
          mob ? 'calc(100dvh - 20px)' : 'calc(100dvh - ' + (TASKBAR_H + 24) + 'px)',
          { vlak: '#fff', vol: true, rand: mob ? 10 : 24 }),
        // 44, net als het invulveld ernaast. Op 46 stonden ze een pixel scheef.
        viewerBtnStyle: { gap: '8px', height: '44px', flex: '0 0 auto', padding: '0 14px' },
        // Alleen als er iets in staat: een verzoekje of een thema. Leeg hield hij toch
        // dertig pixels vrij, en dan begon de tekening 56 onder de titelbalk in plaats
        // van 24, de padding van elk ander venster.
        viewerTopBarStyle: !(viewer && (viewerRequestedFlag || viewerThemaFlag)) ? { display: 'none' }
          : mob
            ? { display: 'flex', alignItems: 'center', gap: '10px', flex: '0 0 auto', minHeight: '30px', margin: '0 0 -6px' }
            : { display: 'flex', alignItems: 'center', gap: '10px', flex: '0 0 auto', minHeight: '30px', margin: '-6px 0 -8px' },
        viewerRowStyle: { display: 'flex', alignItems: 'center', gap: mq('10px', '12px'), marginTop: mq('-4px', '-6px'), flex: '0 0 auto' },
        viewerTitleColStyle: { flex: '1 1 auto', minWidth: '0' },
        // Het hele onderstuk: de reacties plus het tekstvak. Op de telefoon vult het
        // wat er onder de tekening overblijft; op een groot scherm groeit het venster
        // gewoon met zijn inhoud mee, zoals het altijd deed.
        viewerCommentsStyle: mob
          ? { display: 'flex', flexDirection: 'column', gap: '10px', borderTop: '3px solid var(--lila)', paddingTop: '12px', flex: '1 1 auto', minHeight: '0' }
          : { display: 'flex', flexDirection: 'column', gap: '10px', borderTop: '3px solid var(--lila)', paddingTop: '14px' },
        // En de reacties zelf: de strook die schuift. Drie pixels padding en dezelfde
        // negatieve marge, zodat de schaduw onder een reactieblok niet tegen de rand
        // van het scrollgebied wordt afgesneden.
        viewerCommentListStyle: mob
          ? {
              display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '9px', width: '100%',
              flex: '1 1 auto', minHeight: '0', overflowY: 'auto', overscrollBehavior: 'contain',
              padding: '3px', margin: '-3px', boxSizing: 'border-box'
            }
          : { display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '9px', width: '100%' },
        viewerActionsStyle: { display: 'flex', alignItems: 'center', gap: mq('8px', '12px'), flex: '0 0 auto' },
        // Hier stond viewerOverlayStyle: de donkere laag onder de krabbelviewer. Die is
        // weg omdat de viewer een venster is geworden; het dempen doet nu de laag
        // achter alle vensters (vensterDimStyle).
        // Op de telefoon is dit venster altijd schermvullend en scrollt het als
        // geheel niet. Van boven naar onder: de balk met het thema en het kruisje, de
        // tekening op volle breedte, de titel met het hartje, dan de reacties in hun
        // eigen scrollende strook, en onderaan het tekstvak. Dat vak staat dus altijd
        // in beeld; eerst scrollde het hele venster en moest je erheen scrollen om
        // iets te kunnen zeggen.
        // Alleen de binnenruimte; het omhulsel komt van het venster.
        viewerPanelStyle: mob
          ? { flex: '1 1 auto', minHeight: '0', padding: '10px 10px 12px', display: 'flex', flexDirection: 'column', gap: '10px', boxSizing: 'border-box', overflowY: 'auto' }
          : { flex: '1 1 auto', minHeight: '0', padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px', boxSizing: 'border-box', overflowY: 'auto' },
        viewerImgStyle: (() => {
          const wide = !!(viewer && isWide(viewer));
          // Op een computer precies de breedte van de kolom; zie viewerBreed.
          if (!mob) {
            return {
              width: '100%', aspectRatio: wide ? '2/1' : '1/1', height: 'auto',
              imageRendering: 'pixelated', border: '3px solid var(--ink)', borderRadius: '12px',
              background: '#fff', display: 'block', flex: '0 0 auto', boxSizing: 'border-box'
            };
          }
          // Op de telefoon zo breed als het venster toelaat, en dat is de breedte van
          // het scherm min de randen. De bovengrens van 50dvh is er voor lage
          // schermen: zonder die grens duwde een vierkante tekening op volle breedte
          // de reacties en het tekstvak eronder weg. Op een gewone telefoon haalt hij
          // die grens niet, dus daar is hij precies zo breed als het scherm.
          const side = mq('min(100%, 50dvh)', 'min(56vh,420px)');
          const wideW = mq('100%', 'min(84vw,760px)');
          return {
            width: wide ? wideW : side,
            height: wide ? 'auto' : (mob ? 'auto' : side),
            aspectRatio: wide ? '2/1' : (mob ? '1/1' : undefined),
            imageRendering: 'pixelated', border: '3px solid var(--ink)', borderRadius: '12px',
            background: '#fff', display: 'block', alignSelf: 'center', flex: '0 0 auto'
          };
        })(),
        // Grotere kop dan de 19px van een gewoon venster: hier hangt hij onder een
        // tekening van 420px en anders verdrinkt hij eronder.
        viewerTitleStyle: { fontSize: mq('19px', '23px'), fontWeight: 700, lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        viewerMetaStyle: { fontSize: mq('13px', '14px'), color: 'var(--tekst-2)', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '7px' },
        viewerSrc: viewer ? viewer.src : '',
        viewerAlt: viewer ? 'Krabbel “' + (viewer.title || 'zonder titel') + '” van ' + (nameOf(viewer) || viewer.author || 'iemand') : '',
        viewerIsAnim: !!(viewer && viewer.frames > 1),
        viewerIsStatic: !!(viewer && !(viewer.frames > 1)),
        viewerAnimStyle: (() => {
          if (!viewer) return {};
          // Even groot als een stilstaande krabbel. Hier stond 46vh tegen 56vh, en dan
          // was een bewegende krabbel op een scherm van 800 hoog 368 tegen 420.
          const side = mq('min(78vw,340px)', viewerZijde + 'px');
          const n = Math.max(2, Math.min(MAX_FRAMES, Number(viewer.frames) || 2));
          return {
            width: side, height: side,
            backgroundColor: '#fff',
            backgroundImage: 'url(' + viewer.src + ')', backgroundSize: (n * 100) + '% 100%', backgroundRepeat: 'no-repeat',
            imageRendering: 'pixelated', border: '3px solid var(--ink)', borderRadius: '12px',
            display: 'block', alignSelf: 'center', flex: '0 0 auto',
            animation: 'gp-f' + n + ' ' + animDur(n) + 's step-end infinite'
          };
        })(),
        viewerTitle: viewer ? viewer.title : '',
        viewerRequested: !!(viewer && reqByDrawing[viewer.id]),
        viewerThemeMatch: !!(viewer && viewer.isThemeMatch),
        viewerThemeLabel: (() => {
          const t = viewer ? (viewer.themeText || this.themeForDate(viewer.created)) : '';
          return t ? 'Thema: ' + t : 'Thema';
        })(),
        viewerRequestLabel: (() => {
          const r = viewer ? reqByDrawing[viewer.id] : null;
          if (!r) return '';
          const f = accountById[r.fromId];
          return 'Verzoekje van ' + (f ? f.name : 'iemand');
        })(),
        viewerAuthor: viewer ? (viewer.coAuthorId && accountById[viewer.coAuthorId] ? nameOf(viewer) + ' & ' + accountById[viewer.coAuthorId].name : nameOf(viewer) + (isWide(viewer) && !viewer.coAuthorId ? ' (samen)' : '')) : '',
        // Het krabbeltje van de maker staat in de regel eronder, op tekstmaat
        // (20px, 2px rand) net als in de comments — geen tweede knop naast het hartje.
        showViewerAvatar: !!viewer,
        viewerAvatarUrl: (() => {
          const a = viewer && accountById[viewer.accountId];
          return avatarUrl(a ? a.avatar : '');
        })(),
        viewerAuthorTitle: viewer ? (viewer.accountId ? 'Bekijk het profiel van ' + nameOf(viewer) : nameOf(viewer)) : '',
        openViewerAuthor: () => { if (viewer && viewer.accountId) { this.setState({ viewerId: null }); this.openAccount(undefined, viewer.accountId); } },
        viewerWhen: viewer ? relTime(viewer.created) : '',
        viewerLikes: viewer ? viewer.likesCount : 0,
        viewerHeartGevuld: !!(viewer && this.didILike(viewer)),
        /**
         * Het hartje doet twee dingen, en welke van de twee hangt af van wiens
         * krabbel het is.
         *
         * Is hij van jou, dan valt er niets te liken: je eigen werk een hartje geven
         * is geen hartje. Een tik opent dan de lijst met wie het wél leuk vond, en op
         * de telefoon is dat de enige manier om die lijst te zien. Daar stond een
         * tweede knop met een poppetje voor; die is weg.
         *
         * Is hij van iemand anders, dan liket een tik hem. Wie het leuk vond zie je
         * dan alleen op een computer, door het hartje aan te wijzen; dat doet de
         * onMouseEnter in Viewer.jsx en dat werkte al.
         */
        viewerLike: (e) => {
          if (!viewer) return;
          if (this.isMine(viewer)) this.toggleLikers(e);
          else this.toggleLike(viewer.id);
        },
        viewerHeartTitle: viewer && this.isMine(viewer) ? 'Wie vonden dit leuk?' : 'Vind ik leuk',
        showViewerLikers: (viewerLikers.length > 0 || anonLikes > 0) && this.state.likersOpen,
        showLikers: this.showLikers,
        hideLikers: this.hideLikers,
        toggleLikers: this.toggleLikers,
        // Het lijstje hangt vast aan het scherm, zodat geen enkel venster het afsnijdt.
        likersPopStyle: Object.assign({
          background: '#fff', border: '3px solid var(--ink)',
          borderRadius: '12px', boxShadow: '4px 4px 0 var(--ink)', padding: '10px 12px',
          display: 'flex', flexDirection: 'column', gap: '9px',
          minWidth: mob ? '0' : '196px', maxWidth: mob ? 'calc(100vw - 24px)' : '280px',
          // Zonder deze twee liep een lange lijst hartjesgevers boven de bovenrand
          // uit, en dan waren de eerste namen niet te zien en niet te bereiken.
          maxHeight: 'calc(100dvh - 40px)', overflowY: 'auto', overscrollBehavior: 'contain'
        }, this.state.likersAt
          ? (() => {
            // Binnen het scherm houden: op een telefoon valt een gecentreerd
            // lijstje anders links of rechts buiten beeld.
            const vw = typeof window !== 'undefined' ? window.innerWidth : 360;
            const at = this.state.likersAt;
            /**
             * Uitgelijnd op de knop, met de rechterkant van het lijstje op die van de knop.
             *
             * Het hing gecentreerd boven de knop, en die staat rechts in de viewer. Dan
             * liep het lijstje over de rand en duwde de klem het naar links, zodat het
             * nergens meer mee uitlijnde. Rechts op rechts past altijd zolang er links
             * plek is voor het breedste lijstje (280); anders links op links.
             */
            const rechtsOpRechts = typeof at.r === 'number' && at.r - 280 >= 12;
            const plek = rechtsOpRechts
              ? { right: Math.round(vw - at.r) + 'px' }
              : { left: Math.max(12, Math.round(typeof at.l === 'number' ? at.l : at.x - 140)) + 'px' };
            // Boven of onder de knop, en dat hangt af van hoe hoog het lijstje wordt
            // en niet van één vast getal. Met de vaste 170 klapte een lijstje van
            // twaalf namen naar boven open en liep het het scherm uit.
            const hoog = 39 + 31 * Math.max(1, viewerLikers.length) + 20;
            const below = this.state.likersAt.y < hoog;
            return Object.assign({
              position: 'fixed', zIndex: 300,
              top: (below ? at.b + 10 : at.y - 10) + 'px',
              transform: below ? 'none' : 'translateY(-100%)'
            }, plek);
          })()
          : { position: 'absolute', zIndex: 300, bottom: 'calc(100% + 10px)', left: '50%', transform: 'translateX(-50%)' }),
        viewerLikers,
        likersLabel: viewerLikers.length ? 'Geliket door' : 'Geliket',
        showAnonLikes: anonLikes > 0,
        anonLikesLabel: '+ ' + anonLikes + ' anoniem',
        closeViewer: this.closeViewer,
        myNameLabel: this.state.author || 'Account maken',
        hasAvatar: !!myAvatar || !!DEFAULT_AV,
        noAvatar: !myAvatar && !DEFAULT_AV,
        myAvatarUrl: avatarUrl(myAvatar),
        showAccount: this.state.dialog === 'account',
        showWelcome: !!this.state.welcome,
        /**
         * Wat er nieuw is, acht regels in twee kolommen.
         *
         * Het welkomstvenster was een briefje van drie alinea's dat uitlegde wat de
         * paal is. Dat weet iedereen hier nu, en het venster hangt aan een knop die
         * "Wat is er nieuw?" heet: dan hoort er ook nieuws in te staan.
         *
         * Acht is niet toevallig een rond getal maar een rem: past er iets bij, dan
         * moet er iets af, en dan gaat het oudste eruit. Anders wordt dit venster
         * over een half jaar een changelog van vier schermen. Er stonden er tien; de
         * startknop met je eigen kop erop haalde de schifting niet. Het zwevende
         * tekenvenster met zijn knop om groot te maken is weer weg (8 oktober 2026);
         * daar kwam de beestjestekenaar voor in de plaats, die er nu voor iedereen is.
         *
         * Alleen dingen die je ook kunt doen. Het vechten in de arena zit in de code
         * en de server heeft er een tafel voor, maar de knop staat op verzoek uit;
         * zolang dat zo is hoort hij niet in een lijstje met wat er nieuw is. Zie de
         * arenaknop in logic/tamagotchi.js.
         */
        welkomNieuw: [
          { teken: '\u{1F5A5}\uFE0F', tekst: 'De paal hangt op een bureaublad. Je programma\u2019s staan linksboven, de taakbalk onderin.' },
          { teken: '\u{1F58C}\uFE0F', tekst: 'Tekenen vult je hele scherm. Bovenin klap je het weg of doe je het dicht.' },
          { teken: '\u{1F3A8}', tekst: 'Ontwerp je eigen beestje: lijf, ogen en mond. Startmenu, Beestje ontwerpen.' },
          { teken: '\u{1F4E5}', tekst: 'Klap je het weg, dan blijft je krabbel staan. De knop in de balk haalt hem terug.' },
          { teken: '\u{1F31F}', tekst: 'De krabbel van de dag en het gastenboek staan als voorbeeldje op je bureaublad.' },
          { teken: '\u{1F47E}', tekst: 'Krabbelgotchi: een beestje van je eigen krabbels. Voeren, aaien, spelen, licht uit.' },
          { teken: '\u{1F465}', tekst: 'Blader langs de beestjes van je collega\u2019s en geef er een appeltje. Ook zij hebben honger.' },
          { teken: '\u{1F4AC}', tekst: 'De chat is een venster geworden. Hij ligt over je doek, dus je kletst terwijl je krabbelt.' }
        ],
        /**
         * Twee kolommen, en op de telefoon één.
         *
         * Acht regels onder elkaar maakten van dit venster een lijst waar je door
         * moest scrollen; naast elkaar zie je in één blik dat het er acht zijn. Op
         * een telefoon niet: twee kolommen van honderdvijftig pixels breken elke
         * regel in vier stukken.
         */
        welkomLijstStyle: {
          /**
           * Eén rustig vlak, geen achtvoudige lijst van knoppen.
           *
           * Er zaten randjes en vlakjes om alle acht de tekentjes: samen met de
           * gestreepte potlodenkolom links, de tekstballon en de roze knop maakte dat
           * van dit venster een kermis. De tekentjes staan er nu gewoon, zonder vakje,
           * en dit paneel heeft alleen nog een rand. Geen schaduw: het ligt al in een
           * venster dat er zelf een heeft, en dat is diepte in diepte. Zie sectie 5
           * van CLAUDE.md.
           */
          background: '#fff', border: '3px solid var(--ink)', borderRadius: '16px',
          padding: '15px 16px',
          display: 'grid', gridTemplateColumns: mob ? '1fr' : 'repeat(2, minmax(0,1fr))',
          gap: mob ? '14px' : '16px 22px'
        },
        // Het tekentje als opsommingsteken: een vaste kolom van twintig breed, zodat
        // de tekst ernaast op één lijn begint ook al is de ene emoji breder dan de
        // andere.
        welkomTekenStyle: {
          width: '20px', flex: '0 0 auto', fontSize: '16px', lineHeight: '1.25',
          textAlign: 'center'
        },
        openWelcome: this.openWelcome,
        requestFeature: this.requestFeature,
        notifOpen: this.state.notifOpen,
        toggleNotif: this.toggleNotif,
        showNotifDot: !!this.state.notifUnseen,
        appVersion: APP_VERSION,
        notifFeed: notifShown,
        showNotifMore: notifFeed.length > notifLimit,
        notifMoreLabel: 'Meer nieuws (' + Math.min(15, notifFeed.length - notifLimit) + ')',
        toggleNotifMore: () => this.setState({ notifLimit: notifLimit + 15 }),
        notifMoreBtnStyle: {
          flex: '0 0 auto', alignSelf: 'stretch', justifyContent: 'center',
          // De rand was zacht paars en week af van elke andere knop in de app; nu
          // gewoon .gp-btn met inkt, en het reliëf komt uit de CSS.
          borderRadius: '12px', fontWeight: 600,
          fontSize: mq('15px', '13px'), padding: mq('12px 14px', '9px 12px'),
          marginTop: mq('6px', '4px')
        },
        showActivity: this.vensterInfo('activity').open,
        closeActivity: this.closeActivity,
        // Wit kader: dit is een blad met cijfers en geen apparaatje. Op de telefoon
        // vult hij het beeld, zoals hij dat als schermvullende laag ook deed.
        lbVenster: this.vensterVals('activity', 'min(560px,100%)',
          mob ? 'calc(100dvh - 20px)' : 'calc(100dvh - ' + (TASKBAR_H + 24) + 'px)',
          { vlak: '#fff', vol: true, rand: mob ? 18 : 24 }),
        openActivity: this.openActivity,
        lbStreak: withMedals(this.state.accounts.filter((a) => streakOfKey('id:' + a.id) >= 1)
          .slice().sort((a, b) => streakOfKey('id:' + b.id) - streakOfKey('id:' + a.id)).slice(0, 3)
          .map((a) => { const n = streakOfKey('id:' + a.id); return { id: a.id, avatarUrl: avatarUrl(a.avatar), name: a.name, value: n + (n === 1 ? ' dag' : ' dagen') }; }), this.openProfile),
        lbDrawings: withMedals((() => {
          const counts = {};
          this.state.galleryItems.forEach((g) => { const k = keyOf(g); counts[k] = (counts[k] || 0) + 1; });
          return Object.keys(counts).map((k) => {
            const acc = accByKey(k);
            const name = acc ? acc.name : (nameByKey[k] || k.replace(/^name:/, ''));
            return { id: acc ? acc.id : '', avatarUrl: avatarUrl(acc ? acc.avatar : ''), name, n: counts[k] };
          }).sort((a, b) => b.n - a.n).slice(0, 3).map((r) => ({ id: r.id, avatarUrl: r.avatarUrl, name: r.name, value: r.n + ' krabbels' }));
        })(), this.openProfile),
        lbLikes: withMedals((() => {
          const sums = {};
          this.state.galleryItems.forEach((g) => { const k = keyOf(g); sums[k] = (sums[k] || 0) + g.likesCount; });
          return Object.keys(sums).map((k) => {
            const acc = accByKey(k);
            const name = acc ? acc.name : (nameByKey[k] || k.replace(/^name:/, ''));
            return { id: acc ? acc.id : '', avatarUrl: avatarUrl(acc ? acc.avatar : ''), name, n: sums[k] };
          }).sort((a, b) => b.n - a.n).slice(0, 3).map((r) => ({ id: r.id, avatarUrl: r.avatarUrl, name: r.name, value: r.n + ' hartjes' }));
        })(), this.openProfile),
        lbRequests: withMedals((() => {
          const counts = {};
          reqAll.forEach((r) => {
            if (r.status !== 'done') return;
            const who = r.doneBy || r.toId;
            if (!who) return;
            counts[who] = (counts[who] || 0) + 1;
          });
          return Object.keys(counts).map((id) => {
            const acc = accountById[id];
            return { id, avatarUrl: avatarUrl(acc ? acc.avatar : ''), name: acc ? acc.name : 'iemand', n: counts[id] };
          }).sort((a, b) => b.n - a.n).slice(0, 3)
            .map((r) => ({ id: r.id, avatarUrl: r.avatarUrl, name: r.name, value: r.n + (r.n === 1 ? ' verzoekje' : ' verzoekjes') }));
        })(), this.openProfile),
        showFeature: this.state.dialog === 'feature',
        featureText: this.state.featureText || '',
        onFeatureInput: this.onFeatureInput,
        submitFeature: this.submitFeature,
        featureSending: !!this.state.featureSending,
        featureSent: !!this.state.featureSent,
        hasFeatureNote: !!this.state.featureNote,
        featureNote: this.state.featureNote || '',
        featureEmpty: !this.featureVisible().length,
        featureEmptyLabel: this.state.featureLoading ? 'Ideetjes laden…' : { open: 'Geen open ideetjes meer. Wees de eerste met een nieuw idee!', done: 'Nog niks afgevinkt.', declined: 'Nog niks afgewezen.' }[this.state.featureFilter || 'open'],
        /**
         * De drie laden van de ideeënbus.
         *
         * Alleen de eerste heeft een woord nodig. "Gedaan" en "Afgewezen" zijn een
         * vinkje en een kruisje, en die twee woorden waren samen breder dan de rest
         * van de kop: op een telefoon paste de derde lade niet meer op de regel en
         * klapte hij eronder. Een vinkje en een kruisje zeggen hier hetzelfde, want
         * het gaat om afgevinkt tegenover afgewezen, en dat zijn nu net de twee
         * tekens die iedereen daarvoor kent. Het getal erachter blijft staan; de
         * titel op de knop noemt het woord alsnog.
         *
         * Open houdt zijn woord omdat dat de lade is waar je woont. Een derde
         * tekentje ernaast zou raden worden.
         */
        featureTabs: [['open', 'Open', ''], ['done', 'Gedaan', 'vink'], ['declined', 'Afgewezen', 'kruis']].map(([k, label, icoon]) => {
          const on = (this.state.featureFilter || 'open') === k;
          return {
            label, icoon, heeftIcoon: !!icoon,
            count: (this.state.featureList || []).filter((f) => this.featureStatusOf(f) === k).length,
            onClick: () => this.setState({ featureFilter: k }),
            style: 'flex:0 0 auto;height:34px;gap:6px;padding:0 ' + (icoon ? '9px' : '12px') + ';border-radius:12px;font-size:13px;font-weight:600;' + (on ? 'background:var(--paars);color:#fff;' : 'background:#fff;color:var(--ink);'),
            countStyle: 'font-size:11px;font-weight:700;line-height:1;padding:2px 6px;border-radius:999px;border:2px solid ' + (on ? '#fff' : 'var(--ink)') + ';' + (on ? 'color:#fff;' : 'color:var(--ink);background:var(--lila);')
          };
        }),
        isMaintainer: this.isMaintainer,
        openInbox: this.openInbox,
        showInbox: this.state.dialog === 'inbox',
        inboxOverlayStyle: mob
          ? { position: 'fixed', inset: '0', background: 'var(--ink)', zIndex: Z_LAAG, display: 'flex', padding: '10px', overflow: 'hidden', overscrollBehavior: 'contain' }
          : { position: 'fixed', inset: '0', background: 'rgba(36,27,58,.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: Z_LAAG, padding: '20px' },
        inboxModalStyle: mob
          ? { background: '#fff', border: '4px solid var(--ink)', borderRadius: '16px', boxShadow: 'none', width: '100%', height: '100%', padding: '0', display: 'flex', flexDirection: 'column', gap: '0', overflow: 'hidden' }
          : { background: '#fff', border: '4px solid var(--ink)', borderRadius: '24px', boxShadow: '8px 8px 0 var(--ink)', width: 'min(560px,100%)', maxHeight: 'calc(100vh - 60px)', padding: '24px', display: 'flex', flexDirection: 'column', gap: '14px', overflow: 'hidden', boxSizing: 'border-box' },
        inboxHeaderStyle: mob
          ? { flex: '0 0 auto', padding: '16px 16px 0', boxSizing: 'border-box', display: 'flex', alignItems: 'center', gap: '10px' }
          : { display: 'flex', alignItems: 'center', gap: '10px', flex: '0 0 auto' },
        inboxTitleStyle: { fontSize: mq('17px', '19px'), fontWeight: 700, flex: '1 1 auto' },
        inboxBodyStyle: mob
          ? { flex: '1 1 auto', minHeight: '0', display: 'flex', flexDirection: 'column', gap: '14px', padding: '14px 16px 16px' }
          : { display: 'contents' },
        inboxListStyle: mob
          ? { display: 'flex', flexDirection: 'column', gap: '8px' }
          : { display: 'flex', flexDirection: 'column', gap: '8px', overflowY: 'auto', overscrollBehavior: 'contain', minHeight: '0', flex: '1 1 auto', paddingRight: '2px' },
        /**
         * De weg naar een nieuw verzoekje.
         *
         * Die was er niet meer. Het postvakje verwees naar "open iemands profiel
         * in de hal", en de hal bestaat niet meer; er stond dus een uitleg naar een
         * scherm dat weg was. Deze knop opent de lijst met alle plekjes aan de
         * paal, en daar klik je iemand aan om het te vragen.
         */
        naarVerzoek: this.openIedereen,
        naarVerzoekStyle: {
          width: '100%', justifyContent: 'center', height: '48px', boxSizing: 'border-box',
          borderRadius: '12px', fontSize: '16px', fontWeight: 600, flex: '0 0 auto'
        },
        reqEmpty: !reqVisible.length,
        reqEmptyLabel: this.state.reqLoading ? 'Verzoekjes laden…' : 'Nog geen verzoekjes.',
        reqFeed: reqVisible.map((r) => {
          const from = accountById[r.fromId];
          const to = r.toId ? accountById[r.toId] : null;
          const mineOwn = r.fromId === this.state.accountId;
          const done = r.status === 'done';
          const declined = r.status === 'declined';
          const open = isOpenReq(r);
          return {
            id: r.id,
            who: from ? from.name : 'iemand',
            avatarUrl: avatarUrl(from ? from.avatar : ''),
            text: r.text,
            hasTarget: !!to,
            targetName: to ? to.name : '',
            targetAvatarUrl: avatarUrl(to ? to.avatar : ''),
            tag: done ? 'getekend' : (declined ? 'geweigerd' : (mineOwn ? 'van jou' : (to ? 'voor jou' : 'voor iedereen'))),
            tagStyle: {
              flex: '0 0 auto', marginLeft: 'auto', fontSize: '11px', fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase',
              color: done ? 'var(--groen-ink)' : (declined ? 'var(--tekst-3)' : 'var(--ink)'),
              background: done ? 'var(--groen-vlak)' : (declined ? 'var(--lila)' : 'var(--lila-diep)'),
              border: '2px solid ' + (done ? 'var(--groen)' : (declined ? 'var(--rand-stippel)' : 'var(--paars)')), borderRadius: '999px', padding: '2px 8px'
            },
            rowStyle: {
              display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'stretch', width: '100%', boxSizing: 'border-box',
              border: '3px solid ' + (done ? 'var(--groen)' : (declined ? 'var(--rand-stippel)' : 'var(--ink)')), borderRadius: '12px',
              padding: '11px 12px', background: done ? 'var(--groen-vlak)' : (declined ? 'var(--lila)' : 'var(--lila)')
            },
            textStyle: {
              fontSize: '14px', fontWeight: 600, lineHeight: 1.4, whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere', color: done ? 'var(--groen-ink)' : (declined ? 'var(--tekst-3)' : 'var(--ink)')
            },
            hasActions: open && !!this.state.accountId && (mineOwn || (!!to && to.id === this.state.accountId) || !to),
            canDraw: open && !mineOwn && !!this.state.accountId,
            onDraw: () => this.takeRequest({ id: r.id, text: r.text }),
            canCancel: open && mineOwn,
            onCancel: () => this.setRequestStatus(r.id, 'cancelled'),
            canDecline: open && !mineOwn && !!to && to.id === this.state.accountId,
            onDecline: () => this.setRequestStatus(r.id, 'declined')
          };
        }),
        reqText: this.state.reqText || '',
        onReqInput: this.onReqInput,
        showReqCompose: !!this.state.reqTo,
        showReqSent: !!this.state.reqSentTo,
        reqSentLine: (this.state.reqSentTo || '') + ' ziet jouw verzoekje in het postvakje staan.',
        closeReqSent: () => this.setState({ reqSentTo: '' }),
        clearReqTo: () => this.setState({ reqTo: '', reqText: '', reqError: '' }),
        reqPickName: (() => {
          const id = this.state.reqHover || this.state.reqTo;
          const acc = id ? accountById[id] : null;
          return acc ? acc.name : '';
        })(),
        reqPickAvatarUrl: (() => {
          const id = this.state.reqHover || this.state.reqTo;
          const acc = id ? accountById[id] : null;
          return avatarUrl(acc ? acc.avatar : '');
        })(),
        reqPickChipStyle: (() => {
          const hovering = !!this.state.reqHover && this.state.reqHover !== this.state.reqTo;
          return {
            display: 'flex', alignItems: 'center', gap: '6px', flex: '0 1 auto', minWidth: '0',
            fontSize: '13px', fontWeight: 700, color: 'var(--ink)',
            background: hovering ? '#fff' : 'var(--lila-diep)',
            border: '2px solid ' + (hovering ? 'var(--rand-zacht)' : 'var(--paars)'),
            borderRadius: '999px', padding: '3px 10px 3px 4px'
          };
        })(),
        submitRequest: this.submitRequest,
        reqSending: !!this.state.reqSending,
        reqBtnLabel: this.state.reqSending ? 'Versturen…' : 'Versturen',
        hasReqError: !!this.state.reqError,
        reqError: this.state.reqError || '',
        hasTheme: !this.state.themeHidden,
        themeWord: this.themeOfDay(),
        themePopupOpen: !!this.state.themePopup && !this.state.welcome && !this.state.dialog,
        openTheme: this.openTheme,
        hideTheme: this.hideTheme,
        closeTheme: this.closeTheme,
        hasActiveRequest: !!this.state.activeRequest,
        activeRequestText: this.state.activeRequest ? 'Verzoekje: ' + this.state.activeRequest.text : '',
        clearActiveRequest: this.clearActiveRequest,
        // Passen ze er niet allemaal naast, dan zegt het getal hoeveel er nog meer
        // zijn. Passen ze er wel, dan hoeft er niets bij: je ziet ze staan.
        onlineCountLabel: onlineCount > gezichtMax ? '+' + (onlineCount - gezichtMax) : '',
        showOnlineCount: onlineCount > gezichtMax,
        galleryScrollRef: this.galleryScrollRef,
        onPullStart: this.onPullStart,
        onPullMove: this.onPullMove,
        onPullEnd: this.onPullEnd,
        pullRowStyle: {
          height: (this.state.pullY || 0) + 'px', overflow: 'hidden', display: 'flex',
          // Onderaan uitlijnen: zo schuift het rondje onder de menubalk vandaan
          // tevoorschijn in plaats van dat het aan twee kanten wordt afgesneden.
          alignItems: 'flex-end', justifyContent: 'center', flex: '0 0 auto',
          paddingBottom: '4px', boxSizing: 'border-box',
          transition: this.pullFrom == null ? 'height .22s ease' : 'none'
        },
        pullIconStyle: (() => {
          const y = this.state.pullY || 0;
          const armed = y >= PULL_TRIGGER;
          const busy = !!this.state.pullBusy;
          return {
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: '38px', height: '38px', borderRadius: '12px', boxSizing: 'border-box',
            border: '3px solid var(--ink)',
            // Vol paars = ver genoeg getrokken, loslaten ververst de paal.
            background: armed ? 'var(--paars)' : '#fff',
            color: armed ? '#fff' : 'var(--ink)',
            boxShadow: armed || busy ? '3px 3px 0 var(--ink)' : '2px 2px 0 var(--ink)',
            transition: 'background .14s ease, color .14s ease, box-shadow .14s ease',
            opacity: Math.min(1, y / 18),
            // De tegel blijft rechtop en op maat; alleen het pijltje binnenin draait.
            transform: 'none'
          };
        })(),
        pullSpinStyle: (() => {
          const y = this.state.pullY || 0;
          const busy = !!this.state.pullBusy;
          return {
            display: 'block',
            transform: busy ? 'none' : 'rotate(' + Math.round(Math.min(1, y / PULL_TRIGGER) * 210) + 'deg)',
            animation: busy ? 'gpSpin .62s linear infinite' : 'none'
          };
        })(),
        onlineTitle: onlineUsers.map((o) => o.name).join(', ') + ' ' + (onlineCount === 1 ? 'is' : 'zijn') + ' online',
        // Rechtsboven staat wie er nu is: de koppen overlappend naast elkaar, met
        // een woordje erbij. Geen wit vak eromheen; ze rusten gewoon op de roze
        // balk, net als het logo aan de andere kant.
        // De hoek nooit helemaal leeg laten: dan lijkt het alsof er iets stuk is.
        showOnlineBar: true,
        showOnlineFaces: showFaces,
        // Een bolletje in plaats van "NU ONLINE" in kapitalen. De koppen ernaast
        // zeggen al wie er zijn; het bolletje zegt dát ze er zijn. Groen als er
        // iemand is, grijs als het stil is, zodat de hoek nooit leeg staat en er
        // toch geen woord aan te pas komt.
        // Een groen pilletje met het getal erin, achter de koppen. Eerst stond er
        // "NU ONLINE" in kapitalen en dat was te veel woord, daarna een los bolletje
        // en dat was te weinig: een groen puntje van negen pixels naast acht koppen
        // zegt niet dat er iemand ís. Het bolletje zegt nu dat het leeft, het getal
        // hoeveel, en de kleur of er iets te melden valt.
        // Geen pil en geen wit vlak eromheen, maar dezelfde maat, rand en ronding als
        // een kop. Daardoor leest de teller als het laatste lid van de rij in plaats
        // van als een tweede ding ernaast, en dat was wat er niet klopte: koppen én
        // een pilletje, twee groepen waar er één hoort te staan. Een wit vlak zou die
        // eenheid ook geven, maar dan staat er weer een doos in een egale roze kop,
        // en het logo aan de andere kant rust daar direct op.
        // Wit met een inktrand, het groene bolletje erin, het getal in inkt.
        //
        // Dat is geen nieuwe vorm maar een die hier al twee keer staat: het
        // hartjesbolletje op een krabbel is wit met een inktrand, een klein gekleurd
        // tekentje en een getal in inkt, en het "+n"-vakje in deze rij zelf is wit
        // met dezelfde rand en ronding.
        //
        // Een heel vlak in het groen was het probleem. Groen is in deze app geen
        // kleur om iets van te maken; het is de markering dat iemand er is, en die
        // staat als bolletje naast elke naam in de lijst en op elk profiel. Als vlak
        // werd het een negende kleur in een palet van acht.
        // Het bolletje met het aantal, achter de koppen. Een dun streepje ervoor
        // scheidt de twee zonder er een tweede vakje van te maken.
        // Het streepje scheidt de koppen van het getal. Staan er geen koppen, dan
        // scheidt het niets en blijft er alleen een streepje in een knop over.
        onlineChipStyle: Object.assign({
          flex: '0 0 auto', display: 'inline-flex', alignItems: 'center', gap: '6px', alignSelf: 'stretch'
        }, showFaces
          ? { padding: '0 0 0 8px', marginLeft: '2px', borderLeft: '2px solid rgba(36,27,58,.15)' }
          : { padding: '0 2px' }),
        // Precies het bolletje uit de mensenlijst en van een profiel: dezelfde maat,
        // dezelfde twee kleuren. Groen als er iemand is, grijs als het stil is.
        onlineChipDotStyle: {
          width: '8px', height: '8px', borderRadius: '50%', flex: '0 0 auto',
          background: onlineCount > 0 ? 'var(--groen)' : 'var(--uit)',
          border: '2px solid var(--ink)', boxSizing: 'content-box'
        },
        onlineChipCount: String(onlineCount),
        onlineChipCountStyle: { fontSize: '13px', fontWeight: 700, lineHeight: 1, color: 'var(--ink)' },
        // Op de telefoon zijn deze koppen 28 hoog en overlappen ze elkaar 11 pixels,
        // dus er blijft per kop 17 bij 28 over om aan te tikken. Daar wordt niemand
        // blij van, en de mensenlijst staat op mobiel toch al in het startmenu. Dus
        // daar zijn ze alleen om te kijken; aanklikken kan op desktop, waar je een
        // muis hebt.
        /**
         * De koppen van wie er nu is, rechtsboven in de kop.
         *
         * Elke kop is een echte knop, net als het bolletje met het aantal ernaast.
         * Het waren losse plaatjes met een rand eromheen, en dan zie je niet dat je
         * erop kunt klikken; nu wippen ze op als je ze aanwijst en zakken ze weg als
         * je ze indrukt, zoals elke andere knop hier.
         *
         * De schaduw komt van .gp-btn en staat hier dus niet in de stijl. Dat is met
         * opzet: een inline-schaduw wint van de CSS en dan kunnen :hover en :active
         * hem niet meer veranderen.
         *
         * Ze blijven elkaar met elf pixels overlappen. Daardoor valt de schaduw van
         * de ene kop op de volgende, en omdat de eerste bovenop ligt leest de rij als
         * een uitgelegd kaartspel in plaats van als een streep losse vierkantjes.
         */
        onlineFaces: onlineAvatars.map((o, i) => ({
          name: o.name + ' is online',
          avatarUrl: avatarUrl(o.avatar),
          style: {
            width: mob ? '24px' : '28px', height: mob ? '24px' : '28px',
            flex: '0 0 auto', border: '2px solid var(--ink)', borderRadius: '8px',
            background: '#fff', padding: '0', overflow: 'hidden', boxShadow: 'none',
            marginLeft: i === 0 ? '0' : '-8px', objectFit: 'cover',
            imageRendering: 'pixelated', display: 'block',
            position: 'relative', zIndex: String(20 - i)
          }
        })),
        // Hoeveel er nog volgen als ze er niet allemaal bij passen. Geen eigen vakje:
        // het staat al in een vakje.
        onlineRestStyle: {
          marginLeft: '4px', flex: '0 0 auto', fontSize: '12px', fontWeight: 700,
          color: 'var(--tekst-2)', lineHeight: 1
        },
        /**
         * Wie er nu is: één knop met de koppen erin en het aantal erachter.
         *
         * Het waren losse dingen op de roze balk: een rij koppen met elk hun eigen
         * rand en schaduw, en daarnaast nog een wit vakje met een bolletje en een
         * getal. Twee soorten omlijning naast elkaar die niets met elkaar te maken
         * leken te hebben, terwijl het één mededeling is.
         *
         * Nu is het één knop, en die doet ook één ding: hij opent "Iedereen hier",
         * de lijst met alle plekjes aan de paal. Daarvoor was elke kop een eigen
         * knopje naar dat ene profiel, en dat werkte niet: ze overlappen elkaar met
         * acht pixels, dus van de meeste koppen was alleen een streepje aan te
         * klikken. En je kunt maar één rij koppen kwijt, dus wie er niet in paste was
         * helemaal niet te bereiken. Vanuit de lijst kun je iedereen aanklikken.
         *
         * De rand en de schaduw komen van .gp-btn, niet uit deze stijl. Dat is met
         * opzet: een inline-schaduw wint van de CSS en dan kunnen :hover en :active
         * hem niet meer veranderen, en dan wipt de knop niet op en zakt hij niet weg.
         */
        onlineBarStyle: {
          position: 'relative', flex: '0 0 auto', display: 'flex', alignItems: 'center',
          gap: mob ? '6px' : '7px', boxSizing: 'border-box',
          height: mob ? '36px' : '40px', padding: mob ? '0 8px 0 4px' : '0 9px 0 4px',
          borderRadius: '12px', pointerEvents: 'auto'
        },
        /**
         * De lijst met iedereen, en met opzet niet de invulvelden.
         *
         * openAccount kiest zelf of je in de lijst of in de invulvelden landt, en voor
         * wie hier nog nooit was is dat het tweede. Vanaf deze knop is dat altijd de
         * lijst: er staat een rij koppen op, je klikt erop om die mensen te zien.
         */
        openIedereen: this.openIedereen,
        showAccountBtn: false,
        versionBadgeStyle: {
          order: 2, flex: '0 0 auto', alignSelf: 'center', position: 'relative', zIndex: 3, marginTop: '4px',
          fontSize: '11px', fontWeight: 700, letterSpacing: '.04em', color: 'var(--ink)', background: '#fff',
          border: '3px solid var(--ink)', borderRadius: '8px', padding: '3px 8px',
          cursor: 'pointer', lineHeight: 1.2, pointerEvents: 'auto'
        },
        gridW: GW,
        gridH: GH,
        duoIdle: !this.state.duo,
        duoActive: !!this.state.duo,
        openDuoPick: this.openDuoPick,
        endDuo: () => this.endDuo(),
        showDuoPick: this.state.dialog === 'duoPick',
        hasDuoError: !!this.state.duoError,
        duoError: this.state.duoError || '',
        duoCandidates: this.state.accounts.filter((a) => a.id !== this.state.accountId)
          .slice().sort(byName)
          .map((a) => ({
            name: a.name, avatarUrl: avatarUrl(a.avatar), onPick: () => this.startDuo(a),
            dotStyle: { width: '12px', height: '12px', borderRadius: '50%', flex: '0 0 auto', border: '3px solid var(--ink)', background: onlineUsers.some((o) => o.id === a.id) ? 'var(--groen)' : 'var(--uit)' }
          })),
        duoPartnerAvatar: avatarUrl(duoPartner ? duoPartner.avatar : ''),
        duoBannerText: this.state.duo
          ? (this.state.duo.status === 'active'
              ? 'Samen krabbelen met ' + (duoPartner ? duoPartner.name : this.state.duoPartnerName) + '. Teken maar los!'
              : 'Wachten tot ' + (duoPartner ? duoPartner.name : this.state.duoPartnerName) + ' meedoet…')
          : '',
        showDuoInvite: !!this.state.duoInvite,
        duoInviteAvatar: avatarUrl(duoInviter ? duoInviter.avatar : ''),
        duoInviteText: (duoInviter ? duoInviter.name : 'Iemand') + ' wil samen krabbelen!',
        acceptDuo: this.acceptDuo,
        declineDuo: this.declineDuo,
        showDmCompose: this.state.dialog === 'dm',
        openDmPicker: this.openDmPicker,
        dmBackToPicker: this.dmBackToPicker,
        dmPicking: this.state.dialog === 'dm' && !this.state.dmTo,
        dmWriting: this.state.dialog === 'dm' && !!this.state.dmTo,
        dmCandidates: this.state.accounts.filter((a) => a.id)
          .slice().sort(byName)
          .map((a) => ({
            name: a.name, avatarUrl: avatarUrl(a.avatar), onPick: () => this.openDm(a),
            onHover: () => this.setState({ dmHover: a.name }),
            dotStyle: {
              position: 'absolute', top: '-5px', right: '-5px', width: '11px', height: '11px', borderRadius: '50%',
              border: '3px solid var(--ink)', background: onlineUsers.some((o) => o.id === a.id) ? 'var(--groen)' : 'var(--uit)'
            }
          })),
        dmClearHover: () => this.setState({ dmHover: '' }),
        dmHoverName: this.state.dmHover || 'Wijs iemand aan om de naam te zien.',
        dmHoverStyle: {
          fontSize: '13px', fontWeight: 700, minHeight: '18px', lineHeight: '18px',
          color: this.state.dmHover ? 'var(--ink)' : 'var(--tekst-3)',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
        },
        showBroadcastPick: this.state.dialog === 'dm' && !this.state.dmTo && this.isMaintainer,
        openBroadcast: this.openBroadcast,
        broadcastLabel: 'Iedereen tegelijk (' + (this.state.accounts || []).filter((a) => a.id).length + ')',
        dmToName: this.state.dmTo ? this.state.dmTo.name : '',
        dmToAvatar: this.state.dmTo && this.state.dmTo.id === '*' ? BROADCAST_AV : avatarUrl(this.state.dmTo ? this.state.dmTo.avatar : ''),
        dmText: this.state.dmText || '',
        onDmInput: this.onDmInput,
        sendDm: this.sendDm,
        closeDm: this.closeDm,
        dmSending: !!this.state.dmSending,
        dmSendLabel: this.state.dmSending ? 'Versturen…' : (this.state.dmTo && this.state.dmTo.id === '*' ? 'Verstuur naar iedereen' : 'Verstuur bericht'),
        hasDmError: !!this.state.dmError,
        dmError: this.state.dmError || '',
        showDmInbox: (this.state.dmInbox || []).length > 0,
        dmMessage: dmCur ? dmCur.text : '',
        dmWhen: (() => {
          if (!dmCur) return '';
          const t = parseTs(dmCur.created);
          if (isNaN(t)) return '';
          const d = new Date(t); d.setHours(0, 0, 0, 0);
          const today = new Date(); today.setHours(0, 0, 0, 0);
          const days = Math.round((today.getTime() - d.getTime()) / 86400000);
          if (days <= 0) return 'Vandaag';
          if (days === 1) return 'Gisteren';
          if (days === 2) return 'Eergisteren';
          if (days <= 6) return 'Eerder deze week';
          if (days <= 13) return 'Vorige week';
          return 'Een tijdje terug';
        })(),
        dismissDm: this.dismissDm,
        dmDismissLabel: (this.state.dmInbox || []).length > 1 ? 'Volgende' : 'Check!',
        showCelebrate: !!this.state.celebrate,
        celebrateTitle: this.state.celebrate ? this.state.celebrate.title : '',
        celebrateLine: this.state.celebrate ? this.state.celebrate.line : '',
        celebrateReady: !!this.state.celebrateReady,
        celebrateBusy: !!this.state.celebrate && !this.state.celebrateReady,
        celebrateGo: this.celebrateGo,
        openLimits: () => this.setState({ dialog: 'limits' }),
        closeLimits: () => this.setState({ dialog: null }),
        showLimits: this.state.dialog === 'limits',
        showKeys: this.state.dialog === 'keys',
        closeKeys: () => this.setState({ dialog: null }),
        // Overzicht van alles wat een plafond heeft, met de stand van nu erbij.
        limitRows: [
          { what: 'Krabbels op de paal', limit: '300 nieuwste', now: this.state.galleryItems.length + ' geladen', sort: 'nieuwste eerst' },
          { what: 'Chatberichten', limit: '200 nieuwste', now: (this.state.chatMessages || []).length + ' geladen', sort: 'nieuwste eerst' },
          { what: 'Reacties', limit: 'geen', now: Object.keys(this.state.comments || {}).length + ' krabbels met reacties', sort: 'alle pagina\u2019s' },
          { what: 'Accounts', limit: '200 oudste', now: (this.state.accounts || []).length + ' geladen', sort: 'oudste eerst' },
          { what: 'Verzoekjes', limit: '100 nieuwste', now: (this.state.reqList || []).length + ' open', sort: 'voltooid: weg na 1 dag' },
          { what: 'Ideeënbus', limit: '200 nieuwste', now: (this.state.featureList || []).length + ' geladen', sort: 'nieuwste eerst' },
          { what: 'Ongelezen berichten', limit: '20 per keer', now: (this.state.dmUnread || []).length + ' ongelezen', sort: 'oudste eerst' },
          { what: 'Pixels gastenboek', limit: GB_PER_DAY + ' per dag', now: (GB_PER_DAY - this.state.gbUsed) + ' over vandaag', sort: 'per persoon' },
          { what: 'Undo gastenboek', limit: '40 stappen', now: 'binnen sessie', sort: 'lokaal' },
          { what: 'Nieuwsberichten', limit: '80 items', now: 'lokaal samengesteld', sort: 'nieuwste eerst' },
          { what: 'Tekens per reactie', limit: COMMENT_MAX_CHARS + ' tekens', now: 'per reactie', sort: 'lokaal' }
        ].map((r, i) => Object.assign({}, r, {
          rowStyle: {
            display: 'grid', gridTemplateColumns: '1.15fr .8fr .9fr', gap: '10px', alignItems: 'baseline',
            padding: '9px 11px', borderRadius: '12px', fontSize: '13px', fontWeight: 600,
            background: i % 2 ? 'var(--lila)' : '#fff', border: '2px solid var(--lila)'
          }
        })),
        showDailyPicker: this.state.dialog === 'dailyPick',
        openDailyPicker: this.openDailyPicker,
        closeDailyPicker: () => this.setState({ dialog: 'mod' }),
        dailyPickLine: nextPicked
          ? 'Morgen: “' + nextPicked.title + '” door ' + nextPicked.author + '.'
          : 'Nog niets gekozen: morgen wijst de paal zelf “' + (autoNext ? autoNext.title : '—') + '” aan.',
        dailyTodayLine: pickedDaily
          ? 'Vandaag hangt “' + pickedDaily.title + '” van ' + pickedDaily.author + ' er al.'
          : 'Vandaag koos de paal zelf “' + (autoDaily ? autoDaily.title : '—') + '”.',
        showClearDaily: !!nextPicked,
        clearDailyPick: this.clearDailyPick,
        dailyPickChoices: dailyChoices.map((g) => ({
          src: g.src,
          thumbStyle: (() => {
            const n = Math.max(1, Math.min(MAX_FRAMES, Number(g.frames) || 1));
            return {
              width: '54px', height: '54px', imageRendering: 'pixelated',
              border: '3px solid var(--ink)', borderRadius: '12px', background: '#fff',
              display: 'block', flex: '0 0 auto',
              backgroundImage: 'url(' + g.src + ')',
              backgroundSize: (n * 100) + '% 100%', backgroundRepeat: 'no-repeat',
              animation: n > 1 ? 'gp-f' + n + ' ' + animDur(n) + 's step-end infinite' : 'none'
            };
          })(),
          title: g.title,
          author: g.author,
          onPick: () => this.setDailyPick(g.id),
          showChosen: nextPickedId === g.id,
          rowStyle: {
            width: '100%', display: 'flex', alignItems: 'center', gap: '12px', textAlign: 'left',
            padding: '10px', borderRadius: '16px', fontSize: '15px', justifyContent: 'flex-start',
            background: nextPickedId === g.id ? 'var(--groen-vlak)' : '#fff'
          }
        })),
        showThemeList: this.state.dialog === 'themeList',
        openThemeList: this.openThemeList,
        closeThemeList: this.closeThemeList,
        openProjects: this.openProjects,
        closeProjects: this.closeProjects,
    projError: this.state.projError || '',
        themeError: this.state.themeError || '',
        themeInputStyle: {
          flex: '1 1 auto', width: '100%', minWidth: '0', boxSizing: 'border-box',
          border: '2px solid var(--lila)', borderRadius: '8px', background: '#fff',
          font: 'inherit', fontSize: '12px', fontWeight: '700', color: 'var(--ink)',
          padding: '4px 6px', outline: 'none'
        },
        themeList: this.dayThemes.map((w, i) => {
          const day = i + 1;
          const saved = (this.state.themeWords || {})[day];
          const edit = (this.state.themeEdits || {})[day];
          const isToday = day === new Date().getDate();
          return {
            n: day,
            word: saved || w,
            value: edit !== undefined ? edit : (saved || w),
            onInput: (e) => {
              const v = e.target.value;
              this.setState((st) => ({ themeEdits: { ...st.themeEdits, [day]: v } }));
            },
            onBlur: (e) => {
              const v = (e.target.value || '').trim();
              this.setState((st) => {
                const next = { ...st.themeEdits };
                delete next[day];
                return { themeEdits: next };
              });
              if (v && v !== (saved || w)) this.saveTheme(day, v);
            },
            rowStyle: {
              display: 'flex', alignItems: 'center', gap: '6px', padding: '1px 5px',
              border: '2px solid ' + (isToday ? 'var(--ink)' : 'transparent'),
              borderRadius: '12px', background: isToday ? 'var(--geel-vlak)' : 'transparent', minWidth: '0'
            }
          };
        }),
        showMod: this.state.dialog === 'mod',
        openMod: this.openMod,
        closeMod: () => this.setState({ dialog: null }),
        showGuestbookBtn: !mob,
        showGuestbook: this.vensterInfo('gastenboek').open,
        // Wit kader, en op de telefoon schermvullend zoals hij was.
        gbVenster: this.vensterVals('gastenboek', mob ? '100%' : 'min(560px,100%)',
          mob ? 'calc(100dvh - 20px)' : 'calc(100dvh - ' + (TASKBAR_H + 24) + 'px)',
          { vlak: '#fff', vol: true, rand: mob ? 18 : 24 }),
        // De ondertitel stond in de kop van het paneel; die kop is de titelbalk van
        // het venster geworden en daar past geen tweede regel in. Nu staat hij boven
        // het vel, waar hij ook over gaat.
        gbSubStyle: { fontSize: '12px', fontWeight: 600, color: 'var(--tekst-3)', lineHeight: 1.4, flex: '0 0 auto', width: gbMaat, alignSelf: 'center' },
        openGuestbook: this.openGuestbook,
        closeGuestbook: this.closeGuestbook,
        gbThumb: pixUrl(this.state.gbPixels || GB_EMPTY),
        gbThumbAlt: 'Het gastenboek: één groot vel waar iedereen pixels op zet',
        gbClick: this.gbClick,
        gbHoverEnter: this.gbHoverEnter,
        gbHoverMove: this.gbHoverMove,
        gbHoverOut: this.gbHoverOut,
        gbWrapStyle: {
          // Het vel is altijd vierkant en past zich aan de hoogte van het venster
          // aan, zodat het gastenboek nooit hoeft te scrollen. De wikkel houdt
          // dezelfde maat, zodat het hoverkaartje erop uitgelijnd staat.
          position: 'relative',
          width: gbMaat,
          alignSelf: 'center', flex: '0 0 auto'
        },
        // De kleuren en de knop eronder zijn even breed als het vel. De rij stond
        // links en was 452 breed; het vel was dat op een lager scherm niet meer, en op
        // een hoog scherm juist breder. Dan staat er niets onder elkaar.
        gbRijStyle: mob
          ? { display: 'flex', flexWrap: 'wrap', gap: '8px', width: gbMaat, alignSelf: 'center', flex: '0 0 auto' }
          : { display: 'grid', gridTemplateColumns: 'repeat(10, minmax(0,1fr))', gap: '8px', width: gbMaat, alignSelf: 'center', flex: '0 0 auto' },
        gbKlaarStyle: { display: 'flex', flexDirection: 'column', flex: '0 0 auto', width: gbMaat, alignSelf: 'center' },
        showGbTip: !!this.state.gbTip,
        gbTipName: (() => {
          const t = this.state.gbTip;
          const a = t && accOf({ accountId: t.id });
          return (a && a.name) || 'iemand';
        })(),
        gbTipAvatar: (() => {
          const t = this.state.gbTip;
          const a = t && accOf({ accountId: t.id });
          return avatarUrl(a ? a.avatar : '');
        })(),
        gbTipStyle: (() => {
          const t = this.state.gbTip;
          if (!t) return { display: 'none' };
          return {
            position: 'absolute', left: t.left + 'px', top: t.top + 'px',
            transform: t.below ? 'translate(-50%,0)' : 'translate(-50%,-100%)',
            display: 'flex', alignItems: 'center', gap: '7px', pointerEvents: 'none', zIndex: 3,
            background: 'var(--paars)', color: '#fff', border: '3px solid var(--ink)', borderRadius: '12px',
            boxShadow: '3px 3px 0 var(--ink)', padding: '6px 10px', whiteSpace: 'nowrap',
            fontSize: '13px', fontWeight: 600
          };
        })(),
        gbBoardStyle: {
          width: '100%', display: 'block',
          // Rand 3 en schaduw 3, zoals alles binnen een venster (secties 3 en 5 van
          // CLAUDE.md). Hier stond 4 en 5: de dikte van een venster en een schaduw
          // die nergens anders bestaat.
          aspectRatio: '1 / 1', border: '3px solid var(--ink)', borderRadius: '12px',
          boxShadow: '3px 3px 0 var(--ink)', background: '#fff', cursor: 'crosshair', touchAction: 'manipulation',
          backgroundImage: GB_GRID_URL + ',url(' + pixUrl(this.state.gbPixels || GB_EMPTY) + ')',
          backgroundSize: '100% 100%,100% 100%',
          backgroundRepeat: 'no-repeat,no-repeat',
          imageRendering: 'pixelated'
        },
        gbSwatches: PALETTE_HEX.map((hex, i) => ({
          key: 'gb' + i,
          title: 'Kleur ' + (i + 1),
          onPick: () => this.setState({ gbColor: i }),
          // Gekozen is een roze rand, niet een dikkere. Zo doet het palet in het
          // tekenscherm het ook (zie `palette` hieronder), en zo blijven er drie
          // lijndiktes in de app in plaats van vier.
          // Geen schaduw hier: die heeft .gp-btn al, en een inline schaduw houdt
          // :hover en :active tegen (sectie 5 van CLAUDE.md).
          style: Object.assign({
            padding: '0', borderRadius: '12px', background: hex,
            border: '3px solid ' + (this.state.gbColor === i ? 'var(--roze)' : 'var(--ink)')
          }, gbVakje)
        })),
        gbSubLine: this.state.gbUsed >= GB_PER_DAY
          ? 'Eén vel voor iedereen. Je pixels van vandaag zijn op — morgen mag je weer ' + GB_PER_DAY + '.'
          : 'Eén vel voor iedereen. Je mag vandaag nog ' + (GB_PER_DAY - this.state.gbUsed) + ' van je ' + GB_PER_DAY + ' pixels zetten.',
        gbEraserStyle: Object.assign({
          flex: '0 0 auto', padding: '0', borderRadius: '12px',
          justifyContent: 'center', background: '#fff',
          border: '3px solid ' + (this.state.gbColor < 0 ? 'var(--roze)' : 'var(--ink)')
        }, gbVakje),
        gbUndoStyle: Object.assign({
          flex: '0 0 auto', padding: '0', borderRadius: '12px',
          justifyContent: 'center', background: '#fff'
        }, gbVakje),
        gbNoUndo: !(this.gbUndo || []).length,
        undoGbPixel: this.undoGbPixel,
        gbPickEraser: () => this.setState({ gbColor: -1 }),
        showGbMissing: !!this.state.gbMissing,
        gbMissingHint: 'Het gastenboek kan nog niet bij de server' + (this.state.gbStatus ? ' (' + this.state.gbStatus + ')' : '') + '. Maak in PocketBase een collectie “paal_guestbook” met de tekstvelden “pixels”, “lastBy” en “owners”, en zet de List-, View-, Create- en Update-regels open.',
        // dvh en scrollen. Met 90vh en overflow:hidden knipte dit venster op een
        // telefoon zijn eigen onderkant eraf: de kleurenrij en de Klaar-knop vielen
        // weg en er was geen scrollgebied om ze naar boven te halen.
        // Vlak, rand, ronding en schaduw komen van .gp-venster; zie styles.css.
        gbPanelStyle: {
          // Alleen de binnenruimte; de maat en het omhulsel komen van het venster.
          flex: '1 1 auto', minHeight: '0',
          overflowY: 'auto', overflowX: 'hidden', overscrollBehavior: 'contain',
          padding: mob ? '18px 18px 24px' : '24px 24px 30px', display: 'flex', flexDirection: 'column', gap: '15px', boxSizing: 'border-box'
        },
        // ---- betatesters, in het modgereedschap ----
        showBeta: this.state.dialog === 'beta',
        openBeta: this.openBeta,
        closeBeta: this.closeBeta,
        hasBetaFout: !!this.state.betaFout,
        betaFout: this.state.betaFout,
        betaAantalLabel: (() => {
          const n = (this.state.accounts || []).filter((a) => a.beta).length;
          return n === 1 ? '1 tester' : n + ' testers';
        })(),
        betaLijst: (this.state.accounts || []).slice()
          .sort((a, b) => (b.beta ? 1 : 0) - (a.beta ? 1 : 0)
            || String(a.name || '').localeCompare(String(b.name || '')))
          .map((a) => {
            const aan = !!a.beta;
            const ikzelf = a.id === MAINTAINER_ID;
            return {
              name: a.name || 'onbekend',
              avatarUrl: avatarUrl(a.avatar),
              onClick: () => this.toggleBeta(a.id),
              bezig: this.state.betaBezig === a.id,
              // De mod komt er altijd in, ook zonder vinkje; zie magBeta in
              // logic/arcade.js. Zijn regel zegt dat, in plaats van een vinkje dat
              // niets uitmaakt.
              label: ikzelf ? 'altijd' : (aan ? 'tester' : ''),
              titel: ikzelf ? 'Jij komt er altijd in' : (aan ? a.name + ' is nu tester' : 'Maak ' + a.name + ' tester'),
              rijStyle: {
                display: 'flex', alignItems: 'center', gap: '11px', width: '100%', textAlign: 'left',
                flex: '0 0 auto', boxSizing: 'border-box', padding: '9px 12px', borderRadius: '12px',
                border: '3px solid ' + (aan ? 'var(--groen)' : 'var(--ink)'),
                background: aan ? 'var(--groen-vlak)' : 'var(--lila)',
                opacity: this.state.betaBezig === a.id ? .5 : 1
              },
              naamStyle: { fontSize: '14px', fontWeight: 700, flex: '1 1 auto', minWidth: '0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
              labelStyle: {
                flex: '0 0 auto', height: '19px', padding: '0 8px', borderRadius: '999px',
                background: ikzelf ? 'var(--geel)' : 'var(--groen)', color: ikzelf ? 'var(--geel-ink)' : '#fff',
                border: '2px solid var(--ink)', fontSize: '11px', fontWeight: 700,
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }
            };
          }),

        showSeenLog: this.state.dialog === 'seenlog',
        showSeenLogHint: (this.state.accounts || []).length > 0 && (this.state.accounts || []).every((a) => a.activeSec === null),      openSeenLog: this.openSeenLog,
        closeSeenLog: this.closeSeenLog,
        seenLog: (this.state.accounts || []).slice()
          .sort((a, b) => (parseTs(b.lastSeen) || 0) - (parseTs(a.lastSeen) || 0))
          .map((a) => {
            const t = parseTs(a.lastSeen);
            const on = !!t && now - t < ONLINE_MS;
            const fresh = a.activeDay === dayKey();
            return {
              name: a.name || 'onbekend',
              avatarUrl: avatarUrl(a.avatar),
              stamp: t ? stampTime(t) : 'nooit gezien',
              today: 'vandaag ' + (a.activeSec === null ? 'onbekend' : roughTime(fresh ? a.activeSec : 0)),
              when: t ? relTime(a.lastSeen) : '—',
              rowStyle: 'display:flex;align-items:center;gap:11px;flex:0 0 auto;border:3px solid ' + (on ? 'var(--groen)' : 'var(--ink)') + ';border-radius:12px;padding:9px 12px;background:' + (on ? 'var(--groen-vlak)' : 'var(--lila)') + ';',
              dotStyle: 'width:11px;height:11px;border-radius:50%;flex:0 0 auto;border:2px solid var(--ink);background:' + (on ? 'var(--groen)' : 'var(--uit)') + ';',
              whenStyle: 'flex:0 0 auto;font-size:12px;font-weight:700;color:' + (on ? 'var(--groen-ink)' : 'var(--tekst-3)') + ';'
            };
          }),
        featureFeed: this.featureVisible().map((f) => {
          const voters = (f.votedBy || '').split('\n').map((v) => v.trim()).filter(Boolean);
          const mine = voters.indexOf(this.voteKey()) >= 0 && !!this.voteKey();
          // Look the author up by id first, so a rename updates their old ideas too.
          const acc = accOf({ accountId: f.authorId || LEGACY_AUTHOR_IDS[f.author], author: f.author });
          const st = this.featureStatusOf(f);
          const done = st === 'done', gone = st === 'declined';
          return {
            id: f.id, text: f.text, votes: f.votes,
            author: (acc && acc.name) || f.author || 'anoniem',
            avatarUrl: avatarUrl(acc ? acc.avatar : ''),
            meta: relTime(f.created) + (st === 'open' ? '' : ' · ' + f.votes + (f.votes === 1 ? ' stem' : ' stemmen')),
            voteTitle: mine ? 'Haal je stem terug' : 'Stem op dit idee',
            // Actiekolom: 46 + 6 + 46 = 98px voor de mod, anders alleen de stemknop van 46.
            actionsStyle: 'display:flex;flex-direction:column;align-items:stretch;gap:6px;flex:0 0 auto;width:' + (this.isMaintainer ? '98px' : st === 'open' ? '46px' : '0') + ';',
            voteStyle: 'display:flex;align-items:center;justify-content:center;gap:5px;flex:0 0 auto;width:100%;height:46px;padding:0;cursor:pointer;font-family:inherit;color:var(--ink);border:3px solid var(--ink);border-radius:12px;background:' + (mine ? 'var(--roze-vlak)' : '#fff') + ';box-shadow:3px 3px 0 var(--ink);',
            onVote: () => this.voteFeature(f.id),
            solved: done,
            declined: gone,
            showVote: st === 'open',
            rowStyle: 'display:flex;gap:12px;align-items:flex-start;border:3px solid ' + (done ? 'var(--groen)' : gone ? 'var(--rand-stippel)' : 'var(--ink)') + ';border-radius:12px;padding:11px 12px;background:' + (done ? 'var(--groen-vlak)' : gone ? 'var(--lila)' : 'var(--lila)') + ';',
            textStyle: 'font-size:14px;font-weight:600;line-height:1.4;white-space:pre-wrap;overflow-wrap:anywhere;' + (done ? 'color:var(--groen-ink);' : gone ? 'color:var(--tekst-2);' : ''),
            solveTitle: done ? 'Toch nog niet gedaan' : 'Markeer als gedaan',
            solveStyle: 'display:flex;align-items:center;justify-content:center;flex:1 1 0;height:30px;cursor:pointer;font-family:inherit;color:' + (done ? 'var(--groen-ink)' : 'var(--tekst-3)') + ';border:3px solid ' + (done ? 'var(--groen)' : 'var(--ink)') + ';border-radius:12px;background:' + (done ? 'var(--groen-vlak)' : '#fff') + ';box-shadow:3px 3px 0 ' + (done ? 'var(--groen)' : 'var(--ink)') + ';',
            onToggleSolved: () => this.toggleSolved(f.id),
            declineTitle: gone ? 'Toch weer openzetten' : 'Dit ideetje afwijzen',
            declineStyle: 'display:flex;align-items:center;justify-content:center;flex:1 1 0;height:30px;cursor:pointer;font-family:inherit;color:' + (gone ? 'var(--tekst-2)' : 'var(--tekst-3)') + ';border:3px solid ' + (gone ? 'var(--tekst-3)' : 'var(--ink)') + ';border-radius:12px;background:' + (gone ? 'var(--lila-diep)' : '#fff') + ';box-shadow:3px 3px 0 ' + (gone ? 'var(--tekst-3)' : 'var(--ink)') + ';',
            onToggleDeclined: () => this.toggleDeclined(f.id)
          };
        }),
        hasFeatureError: !!this.state.featureError,
        featureError: this.state.featureError,
        featureBtnLabel: this.state.featureSending ? 'Versturen…' : 'Versturen',
        closeWelcome: this.closeWelcome,
        editName: this.state.editName,
        onNameInput: this.onNameInput,
        avStopPaint: this.avStopPaint,
        avPickEraser: this.avPickEraser,
        avClear: this.avClear,
        // Twee gereedschappen: tekenen, of een vlak aanwijzen.
        avTool: this.state.avTool,
        avPickPen: () => this.avPickTool('pen'),
        avPickSel: () => this.avPickTool('sel'),
        avPenStyle: {
          padding: '0', justifyContent: 'center', ...AV_VAK,
          background: this.state.avTool === 'pen' ? 'var(--paars)' : '#fff',
          color: this.state.avTool === 'pen' ? '#fff' : 'var(--ink)'
        },
        avSelStyle: {
          padding: '0', justifyContent: 'center', ...AV_VAK,
          background: this.state.avTool === 'sel' ? 'var(--paars)' : '#fff',
          color: this.state.avTool === 'sel' ? '#fff' : 'var(--ink)'
        },
        // De rechtermuisknop gumt, dus het browsermenu mag hier niet opengaan.
        onAvatarContext: (e) => e.preventDefault(),
        avOpnieuwLabel: 'Opnieuw',
        avEraserStyle: {
          width: '100%', ...AV_VAK, display: 'flex', alignItems: 'center', justifyContent: 'center',
          borderRadius: '12px', cursor: 'pointer', padding: '0', boxSizing: 'border-box',
          border: this.state.avColor < 0 ? '3px solid var(--roze)' : '3px solid var(--ink)',
          background: '#fff', color: 'var(--ink)'
        },
        avatarPalette: PALETTE_HEX.map((c, i) => ({
          // Ligt er een vlak, dan vult een kleur dat vlak in één keer. Zonder vlak
          // kies je hem gewoon om mee te tekenen. Zo doet het grote doek het ook.
          onClick: () => { if (!this.avVulSel(i)) this.setState({ avColor: i }); },
          // Een knop zonder tekst heeft een naam nodig, anders hoort een schermlezer
          // acht keer "knop".
          titel: 'Kleur ' + (i + 1),
          gekozen: this.state.avColor === i,
          // Geen vierkantje meer maar een chip van dezelfde maat als de knoppen
          // eronder. Vier op een rij, twee rijen, en dan het gereedschap: zo staat er
          // niets meer half en zit er geen gat in de rij.
          style: {
            width: '100%', ...AV_VAK, borderRadius: '12px', background: c, cursor: 'pointer', boxSizing: 'border-box',
            border: this.state.avColor === i ? '3px solid var(--roze)' : '3px solid var(--ink)'
          }
        })),
        // Opnieuw is één vakje als alle andere. Als volle balk trok hij meer aandacht
        // dan het tekenen zelf, en in een te smal vakje stond er "Opnieu".
        // Geen schaduw in deze stijl: die komt van .gp-btn, en alleen daar kunnen
        // :hover en :active hem veranderen.
        avOpnieuwStyle: {
          width: '100%', ...AV_VAK, boxSizing: 'border-box', padding: '0',
          justifyContent: 'center', borderRadius: '12px'
        },
        avGumGekozen: this.state.avColor < 0,
        /**
         * Het aangewezen vlak, als één rechthoek over het raster.
         *
         * Zo tekent het doek het ook (selSvgStyle en selPathD hieronder): een lichte
         * paarse vulling met een lopende stippelrand eromheen. De rand loopt langs de
         * vakjesranden en niet door de middens, zodat hij precies samenvalt met de
         * pixels die je verplaatst.
         *
         * De dikte staat in schermpixels (vector-effect), want dit raster is acht
         * eenheden breed en het doek tweeëndertig; met rastereenheden zou dezelfde
         * waarde hier vier keer zo dik uitpakken.
         */
        avSelVak: (() => {
          const r = this.avPreviewRect() || this.state.avSel;
          if (!r) return null;
          return { x: r.x, y: r.y, w: r.w, h: r.h };
        })(),
        avSelSvgStyle: { position: 'absolute', inset: '0', pointerEvents: 'none', zIndex: 2 },
        avSelVakStyle: { animation: 'gpAvAnts .5s linear infinite' },
        avGridRef: this.avGridRef,
        avatarCells: Array.from({ length: AV * AV }, (_, i) => {
          const ch = editAvatar[i];
          const idx = ch === '.' ? -1 : parseInt(ch, 16);
          return {
            onDown: (e) => this.avDown(i, e),
            onEnter: () => this.avEnter(i),
            style: {
              width: '100%', height: '100%',
              cursor: this.state.avTool === 'sel' ? (this.avInSel(i) ? 'move' : 'crosshair') : 'crosshair',
              background: idx >= 0 && PALETTE_HEX[idx] ? PALETTE_HEX[idx] : 'transparent',
              // Het vakje zelf krijgt geen paarse rand meer: het vlak wordt als één
              // rechthoek over het raster getekend, net als op het doek. Anders zie je
              // een raster van paarse hokjes in plaats van één selectie.
              boxShadow: 'inset 0 0 0 1px rgba(36,27,58,.07)'
            }
          };
        }),
        saveAccount: this.saveAccount,
        savingAccount: this.state.savingAccount,
        saveAccountLabel: this.state.savingAccount ? 'Opslaan…' : (this.state.accountId ? 'Wijzigingen opslaan' : 'Account aanmaken'),
  
        openPinSetter: this.openPinSetter,
        showPinButton: true,
        pinButtonLabel: myPinSet || this.state.editPin ? 'Pincode wijzigen' : 'Pincode instellen',
        pinBtnShort: myPinSet || this.state.editPin ? 'Wijzigen' : 'Instellen',
        pinBoxes: [0, 1, 2, 3].map((i) => ({
          value: ((this.state.pinDigits || [])[i] ? '\u2022' : ''),
          filled: !!(this.state.pinDigits || [])[i],
          ref: this.pinRefs[i],
          onInput: (e) => this.pinDigitInput(i, e),
          onKeyDown: (e) => this.pinDigitKey(i, e),
          onFocus: (e) => e.target.select && e.target.select()
        })),
        showPin: !!this.state.pinFor,
        pinTitle: this.state.pinMode === 'claim' ? 'Pincode' : 'Pincode instellen',
        pinSubtitle: this.state.pinMode === 'claim'
          ? 'Dit account is beveiligd. Vul de pincode van vier cijfers in.'
          : 'Kies vier cijfers, zodat niemand anders zich als jou voordoet.',
        submitPin: this.submitPin,
        closePin: this.closePin,
        pinBusy: this.state.pinBusy,
        hasPinError: !!this.state.pinError,
        pinError: this.state.pinError,
        pinBtnLabel: this.state.pinBusy ? 'Bezig…' : (this.state.pinMode === 'claim' ? 'Inloggen' : 'Instellen'),
        hasAccountError: !!this.state.accountError,
        accountError: this.state.accountError,
        hasAccountHint: !!this.state.accountHint,
        accountHint: this.state.accountHint,
        showAccountList: !this.state.profileId && !this.state.accEdit,
        showAccountEditor: !this.state.profileId && !!this.state.accEdit,
        // De hal is vervangen door het startmenu linksonder. Wat hier overblijft is
        // één ding: kies wie je bent, of maak een account aan.
        openAccountEditor: this.openAccountEditor,
        backToAccMenu: () => this.setState({ accEdit: false }),
        ...(() => {
          const last = this.state.accountId ? null : this.knownLastAccount();
          const rec = last && last.name ? last : null;
          return {
            showLastLogin: !!rec,
            lastLoginName: rec ? rec.name : '',
            lastLoginAvatarUrl: avatarUrl(rec ? (rec.avatar || AV_EMPTY) : AV_EMPTY),
            lastLoginGo: () => { if (rec) this.claimAccount(rec); }
          };
        })(),
        // Op een profiel staat er geen titel. De naam van de persoon staat er groot
        // onder en de knop ernaast zegt waar je heen gaat; "Profiel" ertussen is dan
        // een woord dat niets toevoegt.
        accTitleLabel: this.state.profileId ? '' : (this.state.accEdit ? (this.state.accountId ? 'Mijn account' : 'Account aanmaken') : (this.state.accountId ? 'Iedereen hier' : 'Wie ben jij?')),
        profileWrapStyle: mob
          ? {
            display: 'flex', flexDirection: 'column', gap: '14px',
            flex: '1 1 auto', minHeight: '0', overflowY: 'auto', overscrollBehavior: 'contain', padding: '2px 4px 6px 0'
          }
          : { display: 'flex', flexDirection: 'column', gap: '14px', flex: '0 0 auto', padding: '2px 4px 4px 0' },
        showProfile: !!(this.state.profileId && accountById[this.state.profileId]),
        /**
         * Wat er staat als er wel een profiel gevraagd is maar niet gevonden.
         *
         * Het venster en de kop hangen aan profileId, de inhoud pas aan profileId
         * plus een account dat we kennen. Zat daar niets tussen, dan kreeg je een
         * lege witte doos met alleen "Profiel" erin en geen woord over waarom.
         *
         * Dat is op twee manieren te bereiken, en de tweede is de gewone: een link
         * naar iemands profiel openen. applyRoute zet profileId meteen bij het
         * opstarten, terwijl de accountlijst nog onderweg is. Die twee gevallen
         * verdienen niet hetzelfde antwoord, want het eerste lost zichzelf op.
         */
        showProfileLoading: !!this.state.profileId && !accountById[this.state.profileId] && this.state.accounts.length === 0,
        showProfileMissing: !!this.state.profileId && !accountById[this.state.profileId] && this.state.accounts.length > 0,
        profileMissingText: 'Deze krabbelaar staat niet in de lijst. Misschien is het account weg, of is de link ouder dan het account.',
        profileLoadingText: 'Even kijken wie dit is…',
        profileLegeStyle: { fontSize: '14px', fontWeight: 600, color: 'var(--tekst-2)', lineHeight: 1.4, padding: '4px 0 8px' },
        closeProfile: this.closeProfile,
        confirmLogout: this.confirmLogout,
        ...(() => {
          const acc = this.state.profileId ? accountById[this.state.profileId] : null;
          if (!acc) return {};
          const isMe = acc.id === this.state.accountId;
          const isOnline = onlineUsers.some((o) => o.id === acc.id);
          const mine = this.state.galleryItems.filter((g) => (g.accountId ? g.accountId === acc.id || g.coAuthorId === acc.id : g.author === acc.name));
          const hearts = mine.reduce((s, g) => s + (g.likesCount || 0), 0);
          const since = acc.created ? new Date(acc.created) : null;
          const themeCount = mine.filter((g) => g.isThemeMatch).length;
          const duo = mine.some((g) => g.coAuthorId);
          const postbode = mine.some((g) => reqByDrawing[g.id]);
          const nachtuil = mine.some((g) => {
            const d = g.created ? new Date(g.created.replace(' ', 'T')) : null;
            return d && !isNaN(d) && d.getHours() < 4;
          });
          const vroegeVogel = mine.some((g) => {
            const d = g.created ? new Date(g.created.replace(' ', 'T')) : null;
            return d && !isNaN(d) && d.getHours() >= 5 && d.getHours() < 7;
          });
          const streak = streakOf(acc);
          // Vaste maat in plaats van een achtste van de breedte: er staan nu alleen
          // gehaalde badges, dus de rij loopt vol van links naar rechts en slaat om.
          const tile = (earned, bg) => ({
            width: '38px', height: '38px', flex: '0 0 auto', borderRadius: '12px', display: 'flex',
            alignItems: 'center', justifyContent: 'center', cursor: 'default',
            background: bg, border: '3px solid var(--ink)'
          });
          const iconBadge = (earned, label, desc, bg, path, stroke, fill) => ({
            earned, label, desc, titel: label + ' — ' + desc, hasIcon: true, hasText: false, path,
            iconStroke: stroke, iconFill: fill || 'none',
            tileStyle: tile(earned, bg)
          });
          // Elk gekleurd vlak heeft zijn eigen inkt: geel vlak, gele letters. Hier
          // stond altijd de blauwe inkt, ook op de drie gele badges.
          const BADGE_INKT = { 'var(--blauw)': 'var(--blauw-ink)', 'var(--geel-vlak)': 'var(--geel-ink)', 'var(--groen-vlak)': 'var(--groen-ink)', 'var(--lila-diep)': 'var(--paars-donker)', 'var(--roze-vlak)': 'var(--roze-ink)' };
          const textBadge = (earned, label, desc, bg, text) => ({
            earned, label, desc, titel: label + ' — ' + desc, hasIcon: false, hasText: true, text,
            tileStyle: tile(earned, bg),
            textStyle: { fontSize: text.length > 2 ? '11px' : '12px', fontWeight: 700, color: BADGE_INKT[bg] || 'var(--tekst-2)' }
          });
          const FLAME = 'M12 2.4c3.6 3.6 7 6.3 7 10.8a7 7 0 0 1-14 0c0-3.1 1.9-5.3 3.6-7.2.5 1.4 1.3 2.4 2.3 2.9.4-2.4.1-4.4 1.1-6.5Z';
          const badges = [
            iconBadge(streak >= 7, 'Op dreef', '7 dagen op rij getekend', 'var(--oranje-vlak)', FLAME, 'var(--ink)', 'var(--oranje)'),
            iconBadge(mine.length >= 1, 'Eerste krabbel', 'Je eerste tekening geplakt', 'var(--blauw)', 'm17 3 4 4-11 11-5 1 1-5Z', 'var(--blauw-ink)'),
            textBadge(mine.length >= 50, 'Vijftig', '50 krabbels geplakt', 'var(--blauw)', '50'),
            iconBadge(themeCount >= 5, 'Thema-vast', '5x op het thema getekend', 'var(--geel-vlak)', 'M4 12.5 9.5 18 20 6', 'var(--geel-ink)'),
            iconBadge(themeCount >= 7, 'Volle week', '7x op het thema getekend', 'var(--geel-vlak)', 'M3.5 5h17v15h-17zM8 2.5v4M16 2.5v4M3.5 10.5h17', 'var(--geel-ink)'),
            iconBadge(postbode, 'Postbode', 'Een verzoekje getekend', 'var(--groen-vlak)', 'M2.5 5.5h19v13h-19zM3 7l9 6 9-6', 'var(--groen-ink)'),
            iconBadge(duo, 'Duo-krabbel', 'Samen aan één tekening', 'var(--lila-diep)', 'M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M14 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75', 'var(--paars-donker)'),
            iconBadge(hearts >= 100, 'Publiekslieveling', '100 hartjes gekregen', 'var(--roze-vlak)', 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l8.8 8.8 8.8-8.8a5.5 5.5 0 0 0 0-7.8Z', 'var(--ink)', 'var(--roze)'),
            iconBadge(nachtuil, 'Nachtuil', 'Getekend na middernacht', 'var(--ink)', 'M21 13.8A9.2 9.2 0 1 1 10.6 2.9a6.6 6.6 0 0 0 10.4 10.9Z', 'var(--geel)', 'var(--geel)'),
            iconBadge(vroegeVogel, 'Vroege vogel', 'Getekend voor 7 uur', 'var(--geel-vlak)', 'M12 3.5v3M5.6 6.6l2.1 2.1M18.4 6.6l-2.1 2.1M3 13h18M6 13a6 6 0 0 1 12 0', 'var(--geel-ink)'),
            iconBadge(streak >= 30, 'Maand op rij', 'Nog te doen: 30 dagen op rij', 'var(--oranje-vlak)', FLAME, 'var(--ink)', 'var(--oranje)'),
            textBadge(mine.length >= 100, 'Honderd', 'Nog te doen: 100 krabbels', 'var(--blauw)', '100'),
            textBadge(mine.length >= 200, 'Tweehonderd', 'Nog te doen: 200 krabbels', 'var(--blauw)', '200'),
            textBadge(themeCount >= 25, 'Thema-kampioen', 'Nog te doen: 25x het thema', 'var(--geel-vlak)', '25'),
            iconBadge(themeCount >= 10, 'Thema-trouw', 'Nog te doen: 10x het thema', 'var(--lila-diep)', 'M12 2.8 4.4 5.6v6.1c0 4.4 3.1 8.2 7.6 9.5 4.5-1.3 7.6-5.1 7.6-9.5V5.6Z', 'var(--paars-donker)'),
            textBadge(false, 'Geheime badge', 'Kom er zelf achter', 'var(--lila)', '?')
          ];
          // Alleen wat iemand heeft gehaald. Er stonden zestien vakjes, waarvan bij
          // de meeste mensen het merendeel gestippeld en leeg: zestien stuks meubilair
          // die niets tonen, met twee regels uitleg eronder over iets wat er niet is.
          // Het cijfer ernaast zegt nog steeds dat er meer te halen valt.
          const gehaald = badges.filter((b) => b.earned);
          return {
            profileName: acc.name,
            profileAvatarUrl: avatarUrl(acc.avatar),
            profileBadgesRowStyle: { display: 'flex', flexWrap: 'wrap', gap: '7px' },
            profileBadges: gehaald,
            badgeScore: gehaald.length + ' / ' + badges.length,
            heeftBadges: gehaald.length > 0,
            geenBadgesTekst: isMe ? 'Nog geen badges. Krabbel iets, dan komt de eerste eraan.' : 'Nog geen badges.',
            geenBadgesStyle: { fontSize: '13px', fontWeight: 600, color: 'var(--tekst-3)' },
            showProfileStreak: streakOf(acc) >= 2,
            profileStreakTitle: (isMe ? 'Je krabbelt ' : acc.name + ' krabbelt ') + streakOf(acc) + ' dagen op rij',
            profileStatus: isOnline ? (isMe ? 'jij, nu online' : 'nu online') : 'even niet online',
            profileDotStyle: {
              width: '11px', height: '11px', borderRadius: '50%', flex: '0 0 auto',
              border: '2px solid var(--ink)', background: isOnline ? 'var(--groen)' : 'var(--uit)'
            },
            // Het veld op de server heet nog steeds bio; dat laten we zo, want daar
            // staan de statussen van iedereen al in. Alleen wat je ziet heet status.
            profileBio: (acc.bio || (isMe ? 'Je hebt nog geen status. Vul er links een in!' : 'Nog geen status.')) + (acc.favFood ? ' · ' + acc.favFood + ' vind ik lekker' : ''),
            profileBioStyle: {
              flex: '0 0 auto', fontSize: '14px', fontWeight: 600, lineHeight: 1.4, textWrap: 'pretty',
              color: acc.bio ? 'var(--tekst-2)' : 'var(--tekst-3)', padding: '2px 0'
            },
            /**
             * De krabbels van deze persoon, klein, om aan te klikken.
             *
             * Dit stond er als drie cijfervakjes: krabbels, hartjes, dagen op rij.
             * Een getal zegt hoeveel iemand gemaakt heeft, de tekeningen zelf zeggen
             * wát. Het aantal staat nu naast het kopje, dus dat cijfer is niet weg.
             *
             * Klikken opent de krabbel op de paal. Dat is dezelfde weg die het
             * nieuwsoverzicht ook neemt: venster dicht, profiel dicht, krabbel open.
             */
            showProfileDrawings: mine.length > 0,
            profileDrawingsEmpty: isMe ? 'Je hebt nog niets aan de paal hangen.' : 'Nog niets aan de paal.',
            profileDrawings: mine.map((g) => {
              // Het bestand is één strook: zoveel beelden naast elkaar als de krabbel
              // heeft, elk zo breed als het doek, en 32 hoog. Een gewoon doek is 32
              // breed, een duowerk 64. Dus 32x32, 64x32 bij twee beelden, 192x32 bij
              // zes, en bij een duo het dubbele daarvan.
              //
              // Ik rekende hier eerst alleen met het aantal beelden en niet met die
              // dubbele breedte, en bij één beeld helemaal niet. Daardoor werd een
              // strook van 192 in een vierkantje van 58 geperst: drie keer verkleind
              // en dan tot moes. Dat waren de wazige.
              //
              // Een duowerk krijgt twee kolommen, want het is ook twee keer zo breed.
              // De hoogte van het spoor bepaalt de maat (`auto 100%`), zodat de
              // verhouding klopt wat er ook voor breedte omheen staat. Bij een
              // gewoon vakje vult het beeld dat precies; bij een duovakje blijft er
              // een paar pixels wit rechts, omdat de tussenruimte tussen twee
              // kolommen meetelt in de breedte maar niet in de hoogte. Zes pixels
              // wit is beter dan vijf procent uitrekken.
              // Het aantal beelden hoeft hier niet meer in de som: `auto 100%` schaalt
              // de hele strook op hoogte en links beginnen laat dan altijd het eerste
              // beeld zien, hoeveel er ook achter staan.
              const breed = isWide(g);
              return {
                title: g.title + ' — ' + (g.likesCount === 1 ? '1 hartje' : g.likesCount + ' hartjes'),
                onOpen: () => this.notifGoDrawing(g.id),
                // Een bewegende krabbel is één lange strook met alle beelden erin.
                // Op zo'n miniatuur laat ik alleen het eerste beeld zien: vijftig
                // dansende vakjes naast elkaar is geen overzicht meer.
                // Volle breedte in plaats van een vaste maat: een raster van zes
                // kolommen die zich verdelen over wat er is. Met vakjes van 56 hield
                // je rechts een reep over die van niets de rand was, en dat las als
                // een rij die niet uit kwam.
                style: {
                  width: '100%', boxSizing: 'border-box',
                  gridColumn: breed ? 'span 2' : 'auto',
                  aspectRatio: breed ? '2 / 1' : '1 / 1',
                  border: '3px solid var(--ink)', borderRadius: '8px', backgroundColor: '#fff',
                  imageRendering: 'pixelated', display: 'block', padding: '0', cursor: 'pointer',
                  backgroundImage: 'url(' + g.src + ')',
                  // Op hoogte schalen en links beginnen: dan staat het eerste beeld
                  // van de strook in beeld en houdt het zijn verhouding, of het nu
                  // één beeld van 32 of zes van 64 zijn.
                  backgroundSize: 'auto 100%',
                  backgroundPosition: 'left center',
                  backgroundRepeat: 'no-repeat'
                }
              };
            }),
            // Zes kolommen die precies de breedte vullen. Drie pixels padding zodat
            // het zoompje aan de randen van het scrollgebied niet wordt afgeknipt,
            // en een negatieve marge zodat het vak zelf toch op de lijn van de rest
            // begint en eindigt.
            profileDrawingsRowStyle: {
              display: 'grid', gridTemplateColumns: 'repeat(6, minmax(0, 1fr))', gap: '7px',
              // dense: een duowerk pakt twee kolommen, en als er aan het eind van een
              // rij maar één over is zou daar een gat vallen. Dense schuift een
              // volgende kleine krabbel in dat gat, zodat het raster sluit.
              gridAutoFlow: 'dense',
              // De rij waarin een duowerk staat is een paar pixels hoger. Bovenaan
              // uitlijnen houdt de bovenkanten van alle vakjes toch op één lijn.
              alignItems: 'start',
              padding: '3px', margin: '0 -3px',
              maxHeight: '244px', overflowY: 'auto', overscrollBehavior: 'contain'
            },
            profileSince: since && !isNaN(since) ? 'Krabbelt mee sinds ' + since.toLocaleDateString('nl-NL', { month: 'long', year: 'numeric' }) : '',
            showProfileRequest: !isMe && !!this.state.accountId,
            profileAskRequest: () => this.askKrabbelFrom(acc.id),
            showProfileClaim: !isMe && !this.state.accountId,
            profileClaim: () => this.claimAccount(acc),
            profileClaimStyle: {
              position: 'relative', zIndex: 1, flex: '1 1 0', minWidth: '0', justifyContent: 'center',
              height: this.state.accountId ? '44px' : '48px', padding: '0 16px',
              background: 'var(--roze)', color: '#fff'
            },
            showProfileLogout: isMe && !!this.state.accountId
          };
        })(),
        accountsEmpty: !this.state.accountsMissing && this.state.accounts.length === 0,
        accountsMissing: this.state.accountsMissing,
        accountList: this.state.accounts.slice().sort((x, y) => {
          const ox = onlineUsers.some((o) => o.id === x.id) ? 0 : 1;
          const oy = onlineUsers.some((o) => o.id === y.id) ? 0 : 1;
          if (ox !== oy) return ox - oy;
          // Niet online? Dan wie het laatst langskwam bovenaan; nooit gezien onderaan.
          const tx = parseTs(x.lastSeen);
          const ty = parseTs(y.lastSeen);
          const vx = isNaN(tx) ? -1 : tx;
          const vy = isNaN(ty) ? -1 : ty;
          if (vx !== vy) return vy - vx;
          return byName(x, y);
        }).map((a, ai, arr) => {
          const isMe = a.id === this.state.accountId;
          const isOnline = onlineUsers.some((o) => o.id === a.id);
          const accStreak = streakOf(a.name);
          return {
            id: a.id,
            name: a.name,
            // Ben je nog niemand, dan is dit scherm een keuzelijst: klikken is
            // inloggen. Ben je al binnen, dan is het een adresboek en kijk je
            // gewoon bij iemand naar binnen.
            onRowClick: () => (this.state.accountId ? this.openProfile(a.id) : this.claimAccount(a)),
            rowTitle: this.state.accountId ? (isMe ? 'Jouw profiel' : 'Bekijk ' + a.name) : 'Ga verder als ' + a.name,
            canAsk: !isMe && !!this.state.accountId,
            askTitle: 'Vraag ' + a.name + ' om een krabbel',
            onAsk: (e) => { e.stopPropagation(); this.askKrabbelFrom(a.id); },
            nameStyle: { fontWeight: 700, fontSize: '14px', lineHeight: 1.2, minWidth: '0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'left' },
            hasStreak: accStreak >= 2,
            streakCount: accStreak,
            streakTitle: a.name + ' krabbelt ' + accStreak + ' dagen op rij',
            // Wie er nu is, en anders wanneer diegene er voor het laatst was.
            whenLabel: isOnline
              ? (isMe ? 'jij, nu online' : 'nu online')
              : (isNaN(parseTs(a.lastSeen)) ? 'nog nooit gezien' : relTime(a.lastSeen)),
            whenStyle: {
              fontSize: '11px', fontWeight: 600, lineHeight: 1.2,
              color: isOnline ? 'var(--groen-ink)' : 'var(--tekst-3)',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
            },
            dotStyle: {
              width: '10px', height: '10px', borderRadius: '50%', flex: '0 0 auto',
              border: '2px solid var(--ink)', background: isOnline ? 'var(--groen)' : 'var(--uit)'
            },
            avatarUrl: avatarUrl(a.avatar),
            // Rij: avatar, naam met laatst gezien eronder, streak en stip rechts.
            rowStyle: {
              position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center',
              gap: '9px', padding: '7px 9px',
              border: isMe ? '3px solid var(--paars)' : '3px solid var(--ink)', borderRadius: '12px',
              background: isMe ? 'var(--lila)' : (isOnline ? 'var(--groen-vlak)' : '#fff'), minWidth: '0',
              width: '100%', boxSizing: 'border-box', cursor: 'pointer', scrollSnapAlign: 'start',
              fontFamily: 'inherit', fontSize: '13px', color: 'var(--ink)', textAlign: 'left'
            }
          };
        }),
        emojiOpen: this.state.emojiOpen,
        toggleEmoji: this.toggleEmoji,
        emojis: EMOJIS.map((ch) => ({ char: ch, onClick: () => this.addEmoji(ch) })),
        // Geen eigen box-shadow: dan doet de knop dezelfde duw-animatie als verzenden en buzz.
        emojiBtnStyle: {
          flex: '0 0 auto', width: '44px', height: '44px',
          justifyContent: 'center', borderRadius: '12px', padding: '0',
          background: this.state.emojiOpen ? 'var(--roze-balk)' : '#fff'
        },
        // De playknop en zes beeldjes hebben met de ondergrens van frameSide minstens
        // 328 pixels nodig. Op een telefoon is er 38 tot 148. Zonder omslaan liepen de
        // beeldjes aan beide kanten gelijk buiten de doos, en links is dat onbereikbaar
        // omdat de pagina daar niet scrollt.
        frameStripStyle: { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto', maxWidth: '100%', boxSizing: 'border-box' },
        canvasBoxStyle: {
          position: 'relative', boxSizing: 'content-box', flex: '0 0 auto',
          width: px + 'px', height: (this.state.canvasPxH || px) + 'px',
          border: '4px solid var(--ink)', borderRadius: '8px', boxShadow: '8px 8px 0 var(--ink)',
          backgroundColor: '#fff',
          backgroundImage: 'linear-gradient(to right, rgba(36,27,58,.06) 1px, transparent 1px),linear-gradient(to bottom, rgba(36,27,58,.06) 1px, transparent 1px)',
          backgroundSize: `${px / GW}px ${px / GW}px`,
          overflow: 'hidden', cursor: this.isSelectTool(this.state.tool) ? 'crosshair' : 'none'
        },
        /**
         * Het tekenscherm staat in de pagina zodra het open is, ook weggeklapt.
         *
         * `showStudio` zegt of het bestaat en `studioZichtbaar` of je het ziet. Dat
         * onderscheid moet er zijn: haal je het doek uit de pagina, dan is je werk weg
         * en moet het uit een bewaarde afbeelding terugkomen. Verbergen doe je dus met
         * een stijl, niet met `return null`. Zie logic/wip.js.
         */
        /**
         * Een tint donkerder achter elk open venster.
         *
         * Zelfde gedachte als de laag onder een schermvullend venster: wat eronder ligt
         * mag naar achteren zakken. Drie dingen maken het anders dan die laag:
         *
         * - Hij vangt geen klikken (`pointerEvents: none`). Bij een schermvullend
         *   venster is de laag de sluitknop; hier niet, want er kunnen er meerdere open
         *   staan en de paal, de pictogrammen en het accountknopje eronder moeten
         *   gewoon blijven werken.
         * - Lichter: .35 tegen .7. Bij een venster gaat de paal naar achteren, hij
         *   verdwijnt niet.
         * - Hij blijft in de pagina staan en gaat op nul als er niets open is, zodat
         *   het aan- en uitgaan een overgang is en geen sprong.
         *
         * Op 89 ligt hij precies tussen de paal en de vensters. De paal zit met al zijn
         * krabbels in een eigen stapelcontext op z-index 1 (nagemeten: een krabbel
         * staat op 127, maar dat is binnen die context), dus deze ene laag dekt hem
         * helemaal. De taakbalk staat op 96 en blijft dus fel: dat is het scherm zelf.
         *
         * Niet op de telefoon. Daar is een venster bijna schermvullend en valt er
         * niets te focussen.
         */
        showVensterDim: !mob,
        vensterDimStyle: {
          position: 'fixed', inset: '0', zIndex: String(Z_VENSTER - 1),
          background: 'rgba(36,27,58,.35)', pointerEvents: 'none',
          opacity: this.vensterOpen() ? '1' : '0',
          transition: 'opacity .18s ease-out'
        },
        showStudio: !!this.state.studioOpen,
        studioZichtbaar: this.tekentNu(),
        // Op de telefoon blijft het tekenscherm het beeld vullen, precies zoals het
        // was; op een computer is het een programmaatje. Zie het antwoord op vraag 1
        // in sectie 12 van CLAUDE.md.
        studioMobiel: !!this.state.isMobile,
        /**
         * Weggeklapt wordt verborgen, niet verwijderd.
         *
         * Haal je het doek uit de pagina, dan is je werk weg en moet het uit een
         * bewaarde afbeelding terugkomen. Vandaar `display: none` en niet `return
         * null`. Zie logic/wip.js.
         *
         * Op een computer gaat die verberging op het venster zelf, want anders bleef
         * er een leeg kader met een titelbalk staan. Op de telefoon is het vlak zelf
         * het hele scherm, dus daar gaat hij daarop.
         */
        studioVenster: (() => {
          const v = this.vensterVals('studio', this.studioBreed() + 'px', this.studioHoog() + 'px');
          /**
           * Schermvullend, met een duidelijke balk bovenin en de taakbalk eronder.
           *
           * Geen zwevend venster meer: hij staat vast tegen de randen, zonder ronding
           * en zonder schaduw, en je sleept hem niet. De titelbalk blijft, want daar
           * zitten wegklappen en sluiten; hij is altijd de roze van een actief venster,
           * want er ligt niets naast.
           */
          if (!mob) {
            const hoog = this.studioHoog() + 'px';
            v.staStyle = Object.assign({}, v.staStyle, {
              // De insets en de auto-marges van de standaardplek moeten allemaal uit,
              // anders centreert hij zichzelf alsnog binnen die doos.
              left: '0', top: '0', right: '0', bottom: 'auto', width: '100%',
              margin: '0', height: hoog, transform: 'none'
            });
            v.kaderStyle = Object.assign({}, v.kaderStyle, {
              height: hoog, maxHeight: hoog, boxSizing: 'border-box',
              border: '0', borderRadius: '0', boxShadow: 'none'
            });
            v.balkStyle = Object.assign({}, v.balkStyle, { cursor: 'default', background: 'var(--roze-balk)' });
            v.sleepAan = () => {};
          }
          if (!this.tekentNu()) v.staStyle = Object.assign({}, v.staStyle, { display: 'none' });
          return v;
        })(),
        studioVlakStyle: !this.state.isMobile || this.tekentNu()
          ? { flex: '1 1 auto', display: 'flex', minHeight: '0' }
          : { display: 'none' },
        studioTitel: 'Tekenen',
        minStudio: this.minStudio,
        sluitStudio: this.sluitStudio,
        // De paal is het bureaublad: op een computer is hij er altijd. Op de telefoon
        // is het nog een of-of, want daar blijft alles zoals het was.
        isGallery: !this.state.isMobile || !this.tekentNu(),
        goStudio: this.goStudio,
        goGallery: this.goGallery,
        // Er zijn geen tabbladen meer. Op een computer is tekenen een programmaatje en
        // de paal het bureaublad; op de telefoon kun je niet tekenen (zie applyRoute).
        showTabs: false,
        /**
         * De balk bovenin is weg op een computer.
         *
         * Wat erin stond blijft, maar zonder balk: het logo en het versienummer
         * linksboven, de pollknop en de online-koppen rechtsboven. Dat is het
         * bureaubladgevoel: geen tweede balk die een strook van je werkvlak afsnoept,
         * en toch alles binnen bereik in de hoeken waar je het verwacht.
         *
         * Op de telefoon blijft de balk staan zoals hij was, met de tabbladen erin.
         */
        headerStyle: mob ? {
          position: 'relative', zIndex: 10, flex: '0 0 auto', display: 'grid',
          gridTemplateColumns: 'minmax(0,1fr) auto auto',
          alignItems: 'center', gap: '8px',
          // Vaste hoogte, gelijk aan de taakbalk onderin. Zonder dat groeide de kop
          // mee met wat erin staat en waren de twee balken net niet even hoog.
          height: TASKBAR_H + 'px', boxSizing: 'border-box',
          padding: '0 12px',
          // Eén egale roze vlakte: geen aparte balkjes of randen binnen de menubalk.
          background: 'var(--roze-balk)', backgroundImage: 'none', borderBottom: '4px solid var(--ink)', overflow: 'visible'
        } : {
          // Over het bureaublad heen in plaats van erboven, dus geen `flex` en geen
          // eigen hoogte: hij snoept niets van de ruimte af.
          position: 'fixed', top: '0', left: '0', right: '0', zIndex: 10,
          display: 'grid', gridTemplateColumns: 'minmax(0,1fr) auto max-content',
          alignItems: 'center', gap: '16px',
          height: TASKBAR_H + 'px', boxSizing: 'border-box', padding: '0 22px',
          background: 'none', border: 'none', overflow: 'visible',
          // Klikken gaat door naar de paal eronder; de knoppen erin zetten hem weer aan.
          pointerEvents: 'none'
        },
        logoStyle: {
          // Dit is een knop (hij opent "Wat is er nieuw?"), maar het tikdoel was niet
          // hoger dan de letters zelf: een kleine 24 pixels. Met padding erboven en
          // eronder en een even grote negatieve marge wordt het raakvlak 44 zonder dat
          // de titel een pixel verschuift.
          padding: '10px 0', margin: '-10px 0',
          order: 1, fontWeight: '700',
          fontSize: mob ? '19px' : (this.state.tightHeader ? '20px' : '26px'),
          letterSpacing: '-0.02em', cursor: 'pointer', pointerEvents: 'auto', whiteSpace: 'nowrap', flex: '0 1 auto', minWidth: '0',
          // Op de telefoon krimpt de titel mee en eindigt met "…" in plaats van te verdwijnen.
          overflow: 'hidden', textOverflow: 'ellipsis', display: 'block'
        },
        /**
         * Het logo en het versienummer staan niet meer op het bureaublad.
         *
         * Op een computer is de hoek linksboven voor de programma's; een naam en een
         * versienummer zijn geen programma. Op de telefoon staan ze nog in de balk,
         * want daar is die balk er nog en is er geen bureaublad.
         *
         * Wat eraan hing blijft bereikbaar: het versienummer ging naar de ideeënbus en
         * die staat in het startmenu, en "Wat is er nieuw?" staat daar nu ook.
         */
        showVersionBadge: mob,
        showLogo: mob,
        showNameLabel: !mob,
        pollBtnStyle: Object.assign({}, hdrBtn, { background: 'var(--geel)' }),
        gallerySidebarStyle: mob
          ? { position: 'static', width: '100%', display: 'none' }
          : {
              // Helemaal in de hoek. Er stond eerst een logo boven, dus begon deze
              // kolom op 74; dat logo is weg en die ruimte hoeft dus niet vrij te
              // blijven. Twintig boven en achttien links: even veel lucht als de
              // accountknop rechtsboven heeft.
              position: 'fixed', left: this.state.narrowHeader ? '12px' : '18px', top: '20px', zIndex: 5,
              width: this.state.narrowHeader ? '164px' : '250px',
              display: 'flex', flexDirection: 'column', gap: this.state.narrowHeader ? '13px' : '15px'
            },
        // Kleurlogica in de zijbalk: roze = wat er vandaag te doen en te zien is
        // (krabbel van de dag, gastenboek, chat), wit = waar je naartoe gaat
        // (account, ververs, leaderboard).
        // Alle knoppen in de kolom naast de paal hebben één maat: even hoog,
        // even breed, zelfde radius. Alleen de inhoud verschilt.
        ...(() => {
          const nh = this.state.narrowHeader;
          const btn = {
            height: nh ? '54px' : '64px', width: '100%', boxSizing: 'border-box',
            borderRadius: nh ? '12px' : '16px', padding: nh ? '0 10px 0 7px' : '0 13px 0 9px',
            gap: nh ? '9px' : '12px', justifyContent: 'flex-start',
            fontSize: nh ? '13px' : '15px', textAlign: 'left', lineHeight: 1.2
          };
          return {
            sidebarBtnStyle: btn,
            dailyBtnStyle: btn,
            sidebarLbStyle: { ...btn, justifyContent: 'space-between', gap: '8px', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden' },
            /**
             * De spelletjes in de zijbalk bij de paal.
             *
             * Ze staan al in het startmenu, maar dat is een menu dat je eerst moet
             * openen. Hier staan de plekken waar je heen kunt zonder klikken, en
             * daar horen ze ook: één rij per spelletje, in dezelfde vorm als de
             * knop naar het leaderbord eronder.
             */
            // Zelfde kadertje als de duimnagels van de andere knoppen.
            sidebarIconBoxStyle: {
              width: nh ? '38px' : '44px', height: nh ? '38px' : '44px', flex: '0 0 auto',
              border: '3px solid var(--ink)', borderRadius: nh ? '9px' : '11px', background: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: nh ? '17px' : '20px'
            }
          };
        })(),
        // Een bewegende krabbel is één strook met alle beelden naast elkaar. Als
        // achtergrond met een animatie zie je er één per keer, in plaats van de
        // hele strook platgeknepen in één vierkantje.
        /**
         * De krabbel van vandaag als voorbeeldje op zijn pictogram.
         *
         * Dezelfde truc als dailyThumbStyle: het plaatje als achtergrond, en bij meer
         * beeldjes een stapsgewijze animatie die door de strook loopt. Alleen op de
         * maat van een pictogram en zonder eigen rand, want dat vak heeft er al een.
         */
        bureaubladDagStyle: (() => {
          const n = Math.max(1, Math.min(MAX_FRAMES, Number(daily && daily.frames) || 1));
          const src = daily ? daily.src : '';
          return {
            width: '100%', height: '100%', imageRendering: 'pixelated', display: 'block',
            backgroundImage: src ? 'url(' + src + ')' : 'none',
            backgroundSize: (n * 100) + '% 100%', backgroundRepeat: 'no-repeat',
            animation: n > 1 ? 'gp-f' + n + ' ' + animDur(n) + 's step-end infinite' : 'none'
          };
        })(),
        bureaubladVelStyle: {
          width: '100%', height: '100%', imageRendering: 'pixelated', display: 'block', objectFit: 'cover'
        },
        dailyThumbStyle: (() => {
          const s = this.state.narrowHeader ? 38 : 44;
          const n = Math.max(1, Math.min(MAX_FRAMES, Number(daily && daily.frames) || 1));
          const src = daily ? daily.src : '';
          return {
            width: s + 'px', height: s + 'px', imageRendering: 'pixelated',
            border: '3px solid var(--ink)', borderRadius: this.state.narrowHeader ? '9px' : '11px',
            background: '#fff', display: 'block', flex: '0 0 auto',
            backgroundImage: src ? 'url(' + src + ')' : 'none',
            backgroundSize: (n * 100) + '% 100%', backgroundRepeat: 'no-repeat',
            animation: n > 1 ? 'gp-f' + n + ' ' + animDur(n) + 's step-end infinite' : 'none'
          };
        })(),
        dailyImgStyle: (() => {
          const s = this.state.narrowHeader ? 38 : 44;
          return { width: s + 'px', height: s + 'px', imageRendering: 'pixelated', border: '3px solid var(--ink)', borderRadius: this.state.narrowHeader ? '9px' : '11px', background: '#fff', display: 'block', flex: '0 0 auto' };
        })(),
        galleryPadStyle: mq('padding:14px;', 'padding:28px;'),
        showDailyPick: !!daily && !mob,
        showTodayUsers: todayUsers.length > 0 && !mob,
        /**
         * De koppen van "wie krabbelde vandaag": vijf naast elkaar in de zijbalk,
         * dus ze rekken mee met de vensterbreedte.
         *
         * Daarom geen vaste ronding van twaalf. Een vakje van 24 breed met een
         * ronding van 12 is een cirkel, en op een smal venster werden dit dus
         * bolletjes terwijl elke andere avatar in de app een vierkantje met ronde
         * hoeken is. Met min() is het twaalf zolang het vakje 48 of breder is en
         * daaronder een kwart van de maat, en dan blijft het altijd een vierkantje.
         */
        todayFaceStyle: {
          width: '100%', aspectRatio: '1', height: 'auto', padding: '0',
          borderRadius: 'min(12px, 25%)', overflow: 'hidden', justifyContent: 'center'
        },
        todayFaceImgStyle: {
          width: '100%', aspectRatio: '1', height: 'auto', objectFit: 'cover',
          imageRendering: 'pixelated', display: 'block'
        },
        showAvatarEditor: !!this.state.avatarEditorOpen,
        openAvatarEditor: this.openAvatarEditor,
        cancelAvatarEditor: this.cancelAvatarEditor,
        closeAvatarEditor: this.closeAvatarEditor,
        editAvatarUrl: avatarUrl(editAvatar),
        hasEditAvatar: /[0-9a-f]/.test(editAvatar) || !!DEFAULT_AV,
        avatarBtnTitle: 'Klik om je avatar te tekenen (8 × 8)',
        noEditAvatar: !(/[0-9a-f]/.test(editAvatar) || !!DEFAULT_AV),
        ...(() => {
          /**
           * Het veldraster van het accountscherm.
           *
           * Links staan vier veldrijen onder elkaar, rechts een avatar met een knop
           * eronder, en die twee kolommen moeten onderaan op dezelfde lijn eindigen.
           * Dat stond er eerder met de hand ingerekend, in een comment die precies
           * uitlegde waarom het klopte: "label 24 + avatar 233 + gap 10 + knop 45".
           * Het klopte niet meer, want links was de tussenruimte 12 en rechts 14, en
           * dan schuift de knop drie pixels weg. Zulke sommen horen niet in een
           * comment maar in code, dan kunnen ze niet meer verouderen.
           *
           * Eén veldrij is een kopje, een beetje lucht, en het vak zelf. Alles wat op
           * een veldplek staat is even hoog, of het een invulveld is of een knop.
           */
          const KOP = 19;      // hoogte van het kopje boven een veld
          const KOP_LUCHT = 5; // tussen kopje en veld
          const VELD = 44;     // een invulveld, en dus ook een knop op die plek
          const LUCHT = 12;    // tussen twee veldrijen
          const rij = KOP + KOP_LUCHT + VELD;
          // Naam, status, favoriete eten, pincode.
          const velden = 4;
          const kolomHoog = velden * rij + (velden - 1) * LUCHT;
          // Wat er rechts overblijft voor de avatar: de kolomhoogte min het kopje
          // erboven en de knop eronder. De avatar zelf is een raster van 8 bij 8, dus
          // hij wordt afgerond naar beneden op een veelvoud van acht; anders vallen de
          // pixels net niet op hele schermpixels. Wat er dan overschiet gaat naar de
          // lucht boven de knop, en zo eindigen de twee kolommen alsnog gelijk.
          const ruimte = kolomHoog - (KOP + KOP_LUCHT) - LUCHT - VELD;
          const avVak = Math.floor(ruimte / AV) * AV;
          const knopLucht = LUCHT + (ruimte - avVak);
          return {
            veldKopStyle: { fontSize: '13px', fontWeight: 600, height: KOP + 'px', marginBottom: KOP_LUCHT + 'px' },
            // Een knop op een veldplek: even hoog als een invulveld ernaast.
            /**
         * De hoofdactie onderaan een venster: roze, volle breedte, gecentreerd label.
         *
         * Stond op vijf hoogtes (42, 44, 46, 48 en 50) en achttien keer met de hand
         * opgeschreven. Achtenveertig is wat twaalf van die achttien al uitrekenden
         * met padding 13 en tekst 16, dus dit is de stand die de meeste vensters al
         * hadden. Een hoofdactie mag hoger zijn dan een veld: hij is de enige knop in
         * het venster die je zoekt.
         */
        hoofdKnopStyle: {
          width: '100%', justifyContent: 'center', height: '48px', boxSizing: 'border-box',
          borderRadius: '12px', fontSize: '16px', fontWeight: 600, flex: '0 0 auto'
        },
        veldKnopStyle: {
              width: '100%', justifyContent: 'center', height: VELD + 'px', boxSizing: 'border-box',
              borderRadius: '12px', fontSize: '15px', fontWeight: 600, flex: '0 0 auto'
            },
            pinTileStyle: {
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              width: '100%', height: VELD + 'px', padding: '0 12px', boxSizing: 'border-box',
              borderRadius: '12px', flex: '0 0 auto'
            },
            avatarPreviewWrapStyle: mob
              ? {
                  width: '100%', maxWidth: '176px', aspectRatio: '1', minHeight: '0',
                  boxSizing: 'border-box', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  border: '4px solid var(--ink)', borderRadius: '16px', background: '#fff', boxShadow: '4px 4px 0 var(--ink)'
                }
              : {
                  width: avVak + 'px', height: avVak + 'px', flex: '0 0 auto',
                  boxSizing: 'border-box', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  border: '4px solid var(--ink)', borderRadius: '16px', background: '#fff', boxShadow: '4px 4px 0 var(--ink)'
                },
            avatarBtnStyle: mob
              ? { width: '100%', justifyContent: 'center', height: VELD + 'px', boxSizing: 'border-box', borderRadius: '12px', fontSize: '15px', fontWeight: 600, marginTop: '10px', flex: '0 0 auto' }
              : { width: '100%', justifyContent: 'center', height: VELD + 'px', boxSizing: 'border-box', borderRadius: '12px', fontSize: '15px', fontWeight: 600, marginTop: knopLucht + 'px', flex: '0 0 auto' },
            accEditRightStyle: mob
              ? { flex: '1 1 100%', minWidth: '0', width: '100%', display: 'flex', flexDirection: 'column', gap: LUCHT + 'px' }
              : { flex: '0 0 ' + avVak + 'px', minWidth: '0', display: 'flex', flexDirection: 'column', gap: LUCHT + 'px' },
            veldLucht: LUCHT + 'px'
          };
        })(),
        accListRef: this.accListRef,
        editBio: this.state.editBio || '',
        onBioInput: this.onBioInput,
        editFavFood: this.state.editFavFood || '',
        onFavFoodInput: this.onFavFoodInput,
        bioCountLabel: (this.state.editBio || '').length + '/' + BIO_MAX,
        bioCountStyle: {
          fontSize: '11px', fontWeight: 700,
          color: (this.state.editBio || '').length > BIO_MAX - 6 ? 'var(--geel-ink)' : 'var(--tekst-3)'
        },
        featureLineStyle: { display: mq('block', 'inline') },
        featureSpaceStyle: mob ? { display: 'none' } : { display: 'inline-block', width: '.3em' },
        /**
         * De naamlijst is geen venster in het midden maar een uitklapmenu in de
         * rechterbovenhoek, met dezelfde vorm als het startmenu linksonder: 336
         * breed, rand van drie, schaduw van zeven.
         *
         * Dat gold eerst alleen als je hem uit de knop rechtsboven opendeed, want,
         * zo stond het hier, kies je je naam terwijl je nog niet binnen bent dan
         * hangt zo'n menu aan een knop die er niet is. Die knop is er wel: de kopjes
         * rechtsboven staan er voor iedereen, ook uitgelogd (showOnlineBar), en het
         * is dezelfde knop die dit scherm opent. Dus hangt de lijst nu altijd in die
         * hoek en is het venster van 640 in het midden er niet meer.
         *
         * Het invulformulier en een profiel staan wél in het midden: die zijn breder
         * dan 336. Vandaar dat accEdit en profileId de hoek hierboven uitzetten.
         */
        // De laag waarop "ernaast klikken" landt. Bij de uitklapper is die
        // doorzichtig, en dan mag hij niet over de taakbalk heen liggen: die laag
        // pikte je volgende klik. Typ je iets in de chatbalk en druk je op
        // verzenden, dan klapt de lijst rechtsboven open terwijl jij linksonder
        // kijkt; je tweede klik op verzenden landde dan op de glasplaat, het
        // paneel ging dicht en je bericht ging niet weg. Nu ligt hij op 69, net
        // onder de taakbalk, precies zoals startBackStyle in logic/desktop.js het
        // doet en om dezelfde reden.
        accOverlayStyle: halHoek && !mob
          ? { position: 'fixed', inset: '0', zIndex: 69 }
          : mob
          ? { position: 'fixed', inset: '0', background: 'var(--ink)', zIndex: 97, display: 'flex', padding: '10px', overflow: 'hidden', overscrollBehavior: 'contain' }
          : { position: 'fixed', inset: '0', background: 'rgba(36,27,58,.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 97, padding: '20px' },
        /**
         * Het kruisje rechtsboven, in elk venster hetzelfde.
         *
         * Twee dingen zaten er scheef. Het stond in het midden van de kopregel, en
         * die regel is zo hoog als de hoogste knop erin: naast een "Terug" van
         * zesenveertig pixels zakte het kruisje dus veertig pixels naar beneden
         * terwijl het maar vierentwintig van de rechterrand stond. Dat leest niet als
         * een hoek. `alignSelf: flex-start` zet het terug op de bovenlijn, dus het
         * staat nu even ver van de bovenrand als van de zijkant.
         *
         * En het raakvlak was achtentwintig pixels. De padding maakt daar tweeënveertig
         * van; de negatieve marge eromheen is precies even groot, dus het tekentje
         * blijft staan waar het staat en alleen het gebied waar je kunt klikken groeit
         * mee, de vensterrand in. Op de telefoon is dit vaak de enige uitgang.
         *
         * Elf en niet twaalf, want de padding van de vensters loopt van twintig tot
         * zesentwintig: met twaalf zou de rand van het raakvlak er bij het smalste
         * venster net buiten vallen.
         */
        sluitStyle: {
          alignSelf: 'flex-start', flex: '0 0 auto',
          border: 'none', background: 'transparent', cursor: 'pointer', color: 'var(--ink)',
          display: 'flex', padding: '11px', margin: '-11px -11px -11px auto', borderRadius: '12px'
        },
        // De titel staat links, naast de knop waarmee je terug gaat, zoals in elk
        // ander venster hier. Er stond space-between, en dan duwen drie kinderen
        // elkaar naar de hoeken: "Mijn account" belandde in het midden, en omdat de
        // knop links breder is dan het kruisje rechts was dat niet eens het midden.
        accHeaderStyle: mob
          ? { flex: '0 0 auto', padding: '16px 16px 0', boxSizing: 'border-box', display: 'flex', alignItems: 'flex-start', gap: '10px' }
          : { display: 'flex', alignItems: 'flex-start', gap: '12px' },
        // Geen vast vak van 310 pixels meer. Dat was er toen de kop nog twee kolommen
        // moest overspannen; sindsdien begon het cijfer erachter op de plek waar die
        // 310 toevallig eindigde, en dat zweefde in het midden.
        // De titel groeit mee, want er moet precies één ding in de kopregel zijn dat
        // dat doet: dan wordt het kruisje naar de rechterhoek geduwd.
        //
        // Achter de titel stond een regeltje "1 van de 26 online", op de onderlijn
        // van de titel. Dat groeide en dat was toen het ding dat het kruisje op zijn
        // plek hield. Het is weg: twee stukken tekst op twee formaten naast elkaar
        // op één regel, en het getal staat toch al in de knop rechtsboven waarmee je
        // dit scherm opent.
        accTitleStyle: { fontSize: mq('17px', '19px'), fontWeight: 700, flex: '1 1 auto', minWidth: '0', lineHeight: '46px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        // Volle breedte, zodat er geen witte reepjes naast de knoppen overblijven
        // waar de inhoud eronderdoor schuift.
        saveBarStyle: mob
          ? {
            position: 'sticky', bottom: '-26px', flex: '0 0 auto', zIndex: 6, background: '#fff',
            margin: '-4px -16px 0', padding: '14px 16px 0', display: 'flex', gap: '8px'
          }
          : { flex: '0 0 auto', display: 'flex', gap: '8px', paddingTop: '16px' },
        accBodyStyle: mob
          ? { flex: '1 1 auto', minHeight: '0', overflowY: 'auto', overscrollBehavior: 'contain', display: 'flex', flexDirection: 'column', gap: '16px', padding: '14px 16px 26px' }
          : { display: 'contents' },
        accModalStyle: halHoek && !mob
          ? {
              position: 'fixed', right: '12px',
              // De kopbalk is net zo hoog als de taakbalk, plus zijn rand van vier;
              // tien pixels eronder, net als het startmenu tien boven de taakbalk.
              top: (TASKBAR_H + 4 + 10) + 'px',
              width: 'min(336px, calc(100vw - 24px))',
              maxHeight: 'calc(100dvh - ' + (TASKBAR_H + 4 + 10 + TASKBAR_H + 32) + 'px)',
              background: '#fff', border: '3px solid var(--ink)', borderRadius: '16px',
              boxShadow: '7px 7px 0 var(--ink)', zIndex: 97,
              display: 'flex', flexDirection: 'column', gap: '12px', padding: '14px',
              overflowY: 'auto', overscrollBehavior: 'contain', boxSizing: 'border-box'
            }
          : mob
          ? {
              background: '#fff', border: '4px solid var(--ink)', borderRadius: '16px', boxShadow: 'none',
              width: '100%', height: '100%', maxHeight: 'none', minHeight: '0', padding: '0',
              display: 'flex', flexDirection: 'column', gap: '0', overflow: 'hidden'
            }
          : {
              background: '#fff', border: '4px solid var(--ink)', borderRadius: '24px', boxShadow: '8px 8px 0 var(--ink)',
              // Een profiel is één kolom met een kop, een rij miniaturen en een knop. Daar
              // is 480 genoeg voor: zes miniaturen van 56 met 7 ertussen passen er in.
              width: this.state.profileId ? 'min(440px,100%)' : (this.state.accEdit ? 'min(640px,100%)' : 'min(640px,100%)'), maxHeight: 'calc(100vh - 60px)', minHeight: '0', padding: '26px', display: 'flex', flexDirection: 'column', gap: '16px',
              overflowY: 'auto'
            },
        accColsStyle: mob
          ? { display: 'flex', gap: '22px', flexWrap: 'wrap', flex: '0 0 auto' }
          : (this.state.profileId || this.state.accEdit
            ? { display: 'flex', gap: '22px', flexWrap: 'nowrap', alignItems: 'flex-start', flex: '0 0 auto' }
            // Kiezen wie je bent is één ding, dus één kolom over de volle breedte.
            : { display: 'flex', flexDirection: 'column', gap: '12px', flex: '1 1 auto', minHeight: '0' }),
        accountListStyle: halHoek && !mob
          ? {
              // In een menu van 336 breed passen geen twee kolommen namen, en het
              // vak eromheen hoeft ook niet: het menu is het vak al.
              display: 'flex', flexDirection: 'column', gap: '7px',
              maxHeight: 'min(52vh, 460px)', overflowY: 'auto', overscrollBehavior: 'contain',
              paddingRight: '4px', marginRight: '-4px'
            }
          : mob
          ? { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gridAutoRows: 'min-content', alignContent: 'start', gap: '7px', paddingBottom: '8px' }
          // Vierentwintig namen onder elkaar wordt een lange sliert; naast elkaar
          // zie je ze in één oogopslag. Scrollen mag, maar het scherm groeit niet
          // verder mee.
          : {
              display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gridAutoRows: 'min-content',
              alignContent: 'start', gap: '8px', maxHeight: 'min(46vh, 420px)', overflowY: 'auto',
              padding: '10px', boxSizing: 'border-box', border: '3px solid var(--ink)',
              borderRadius: '16px', background: 'var(--lila)'
            },
        accLeftColStyle: mob        ? { flex: '1 1 100%', minWidth: '0', width: '100%', display: 'flex', flexDirection: 'column', gap: '12px' }
          : (this.state.accEdit
            ? { flex: '1 1 auto', minWidth: '0', minHeight: '0', display: 'flex', flexDirection: 'column', gap: '12px', alignSelf: 'flex-start', width: '100%' }
            // Het kopje "Iedereen hier" steekt boven de vakken uit: de knoppen
            // links beginnen op dezelfde hoogte als de lijst rechts.
            : { flex: '0 0 300px', minWidth: '0', minHeight: '0', display: 'flex', flexDirection: 'column', gap: '9px' }),
        showAccountRight: !!this.state.profileId || !this.state.accEdit,
        // De terugknop stond op een eigen rij en pakte daarmee een hele regel van de
        // hoogte. Hij hoort naast de titel, net als in het invulscherm.
        showProfileBack: !!this.state.profileId,
        // De enige andere uitweg uit dit scherm: zelf een plekje maken.
        showNewAccountBtn: !this.state.profileId && !this.state.accEdit,
        newAccountLabel: this.state.accountId ? 'Naar mijn account' : 'Ik sta er nog niet bij',
        newAccountStyle: { width: '100%', justifyContent: 'center', height: '48px', borderRadius: '12px', fontSize: '15px' },
        ...this.hallVals(onlineUsers, openForMe, streakOfKey),
        accRightColStyle: { flex: '1 1 auto', minWidth: '0', width: '100%', minHeight: '0', display: 'flex', flexDirection: 'column', gap: '12px' },
        notifListStyle: { display: 'flex', flexDirection: 'column', gap: '8px' },
        notifTitleStyle: { fontSize: mq('20px', '19px'), fontWeight: 700 },
        // Dezelfde roze balk als bij de chat, zodat de twee panelen die uit de
        // taakbalk komen op elkaar lijken. De chat is 56 hoog met 16 binnenruimte;
        // dit paneel is smaller, dus de titel staat op 19 in plaats van 20.
        notifHeaderStyle: {
          flex: '0 0 auto', padding: '0 16px', minHeight: '56px', boxSizing: 'border-box',
          background: 'var(--roze-balk)', borderBottom: '3px solid var(--ink)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px',
          userSelect: 'none'
        },
        notifBodyStyle: {
          flex: '1 1 auto', minHeight: '0', display: 'flex', flexDirection: 'column', gap: '12px',
          padding: mq('16px', '14px'), overflowY: 'auto', overscrollBehavior: 'contain'
        },
        notifCloseIcon: 20,
        /**
         * Een regel nieuws.
         *
         * Dit waren kale regels: een klein avatartje, een emoji, één afgekapte
         * tekstregel en rechts een kolom met de tijd. Drie dingen schuurden. Elke
         * andere lijst in deze app bestaat uit kaartjes met een rand, deze niet.
         * De tekst werd op zestig procent afgekapt met puntjes, dus je las nooit
         * waar het over ging. En die tijdkolom nam een derde van de breedte in
         * beslag voor "1 uur geleden".
         *
         * Nu: een kaartje met een rand van twee (die rijstijl staat per bericht bij
         * notifFeed, want de kleur hangt af van gelezen of niet), het soort als
         * bolletje op de hoek van de avatar, de tekst over maximaal twee regels en
         * de tijd eronder.
         */
        notifAvatarWrapStyle: { position: 'relative', flex: '0 0 auto', lineHeight: 0 },
        notifAvatarStyle: {
          width: '32px', height: '32px', imageRendering: 'pixelated',
          border: '2px solid var(--ink)', borderRadius: '8px', background: '#fff', display: 'block'
        },
        notifBadgeStyle: {
          position: 'absolute', right: '-5px', bottom: '-5px',
          width: '18px', height: '18px', borderRadius: '50%',
          border: '2px solid var(--ink)', background: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '9px', lineHeight: 1
        },
        notifTekstVakStyle: { flex: '1 1 auto', minWidth: '0', display: 'flex', flexDirection: 'column', gap: '0' },
        notifWhenStyle: { color: 'var(--tekst-3)', fontSize: '11px', fontWeight: 600 },
        // De donkere laag onder het leaderbord is weg: het is een venster geworden en
        // de laag achter de vensters (vensterDimStyle) doet het dempen nu.

        /**
         * Alleen nog de inhoud: rand, schaduw, kleur en breedte komen van het venster.
         *
         * Hier stond het hele omhulsel — wit vlak, rand van vier, schaduw van acht,
         * eigen breedte — plus een titelregel met een kruisje erin. Dat is nu de
         * titelbalk van het venster, en wat overblijft is de binnenruimte.
         */
        lbPanelStyle: {
          flex: '1 1 auto', minHeight: '0', overflowY: 'auto', overscrollBehavior: 'contain',
          padding: mob ? '18px' : '24px', display: 'flex', flexDirection: 'column', gap: '16px'
        },
        lbColumnsStyle: mob
          ? { display: 'flex', flexDirection: 'column', gap: '24px' }
          : { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(190px,1fr))', gap: '24px' },
        tabStyle: { studio: this.tabStyle(this.tekentNu()), gallery: this.tabStyle(!this.tekentNu()) },
        tabSliderStyle: {
          position: 'absolute', top: '4px', bottom: '4px', left: '4px', width: 'calc(50% - 4px)',
          borderRadius: '12px', background: 'var(--paars)', pointerEvents: 'none',
          transform: this.tekentNu() ? 'translateX(0%)' : 'translateX(100%)'
        },
  
        connTitle: connected ? 'Verbonden met de server' : 'Niet verbonden',
        connDotStyle: {
          position: 'absolute', top: '-6px', right: '-6px', width: '15px', height: '15px',
          borderRadius: '50%', border: '3px solid var(--ink)',
          background: connected ? 'var(--groen)' : 'var(--rand-zacht)'
        },
  
        canvasRef: this.canvasRef,
        onCanvasLeave: this.onCanvasLeave,
        // Het aanwijskadertje krijgt geen stijl uit renderVals meer: plek en maat
        // gaan rechtstreeks naar de div. Zie setHover in logic/pointer.js.
        hoverRef: this.hoverRef,
        palette: PALETTE_HEX.map((c, i) => ({
          onClick: () => this.pickPaletteColor(i),
          title: 'Kleur ' + (i + 1) + ' (toets ' + (i + 1) + ')',
          style: {
            width: '100%', aspectRatio: '1/1', borderRadius: '12px', background: c, cursor: 'pointer',
            border: i === this.state.primaryIndex ? '3px solid var(--roze)' : '3px solid var(--ink)',
            boxShadow: '2px 2px 0 var(--ink)'
          }
        })),
        toolIconSize: this.toolMetrics().icon,
        toolStroke: iconStroke(this.toolMetrics().icon),
        // Zie TOOL_COL_W: precies breed genoeg om de knoppen vierkant te maken.
        toolColStyle: {
          flex: '0 0 ' + TOOL_COL_W + 'px', background: '#fff', borderRight: '4px solid var(--ink)', display: 'flex',
          flexDirection: 'column', alignItems: 'stretch', padding: '12px 10px',
          // Scrollen in plaats van afknippen. De maat wordt uitgerekend zodat alles
          // past, maar als die som er ooit naast zit hoort de onderste knop
          // bereikbaar te blijven in plaats van weggeklemd te worden.
          gap: this.toolMetrics().gap + 'px', overflowY: 'auto', overflowX: 'hidden'
        },
        selectPen: this.selectPen,
        showLassoIcon: this.state.tool === 'select',
        showMarqueeIcon: this.state.tool !== 'select',
        showLineIcon: this.state.tool === 'line',
        showRectIcon: this.state.tool === 'rect',
        // De cirkel is de ruststand van dit vakje: staat er geen vorm aan, dan
        // toont hij een cirkel.
        showCircleIcon: this.state.tool === 'circle' || !this.isShapeTool(this.state.tool),
        toolLabel: {
          pen: this.toolLabelFor('pen', this.isShapeTool(this.state.tool)),
          pencil: this.toolLabelFor('pencil', this.state.tool === 'pencil'),
          eraser: this.toolLabelFor('eraser', this.state.tool === 'eraser'),
          fill: this.toolLabelFor('fill', this.state.tool === 'fill'),
          select: this.toolLabelFor('select', this.isSelectTool(this.state.tool)),
          hulp: this.toolLabelFor('hulp', !!this.state.hulp),
          spray: this.toolLabelFor('spray', this.state.tool === 'spray')
        },
        toolPressed: {
          pen: this.isShapeTool(this.state.tool),
          pencil: this.state.tool === 'pencil',
          eraser: this.state.tool === 'eraser',
          fill: this.state.tool === 'fill',
          select: this.isSelectTool(this.state.tool),
          spray: this.state.tool === 'spray',
          hulp: !!this.state.hulp
        },
        toolStyle: { pen: this.toolStyle(this.isShapeTool(this.state.tool), 'pen'), pencil: this.toolStyle(this.state.tool === 'pencil', 'pencil'), eraser: this.toolStyle(this.state.tool === 'eraser', 'eraser'), fill: this.toolStyle(this.state.tool === 'fill', 'fill'), select: this.toolStyle(this.isSelectTool(this.state.tool), 'select'), spray: this.toolStyle(this.state.tool === 'spray', 'spray') },
        noBrushDec: this.state.brushSize <= 1,
        noBrushInc: this.state.brushSize >= 4,
        brushMinusStyle: this.brushCellStyle(this.state.brushSize <= 1, 'minus'),
        /**
         * De hulplijnen onder het doek.
         *
         * Kwam uit de ideeënbus: "de optie om je tekening als template te laten
         * gebruiken door anderen, bijvoorbeeld een perfecte kubus of grid". Dat hoeft
         * geen tekening van iemand anders te zijn: als het om een startpunt gaat, dan
         * is een laag onder je doek genoeg. Je tekent eroverheen en er blijft niets
         * van in je krabbel achter.
         *
         * Twee vormen, één knop. Een kubus in isometrisch aanzicht om een blok na te
         * bouwen, en een isometrisch raster van 2:1 lijnen om er een hele wereld op
         * te zetten. Klikken gaat rond: uit, kubus, raster, uit.
         */
        hulpAan: !!this.state.hulp,
        hulpMode: this.state.hulp || '',
        cycleHulp: this.cycleHulp,
        hulpStyle: this.toolStyle(!!this.state.hulp, 'hulp'),
        /**
         * De lijnen zelf, als vakjes van het raster.
         *
         * Geen dunne vectorlijnen: die lopen dwars door de vakjes heen en dan zie je
         * wel waar de lijn ongeveer gaat, maar niet welk vakje je moet aanklikken.
         * lib/guides.js rekent uit welke vakjes de lijn raakt, en die komen hier als
         * één pad met een blokje per vakje. Precies dezelfde maat als wat je erover
         * tekent, dus je kunt hem vakje voor vakje overtrekken.
         *
         * De svg staat op viewBox 0 0 GW GH over het hele doek, dus één eenheid is
         * één vakje, wat het doek ook doet.
         */
        hulpVlak: this.state.hulp === 'kubus'
          ? cellsToPath(cubeCells(GW, GH))
          : this.state.hulp === 'iso'
            ? cellsToPath(isoCells(GW, GH))
            : '',
        // Lichtblauw, en doorzichtig genoeg om onder je eigen kleuren te verdwijnen.
        // Het raster raakt veel meer vakjes dan de kubus, dus dat mag lichter.
        hulpKleur: '#29ADFF',
        hulpDek: this.state.hulp === 'iso' ? 0.3 : 0.55,
        hulpSvgStyle: { position: 'absolute', inset: '0', width: '100%', height: '100%', pointerEvents: 'none', display: 'block' },
        hulpViewBox: '0 0 ' + GW + ' ' + GH,
        brushPlusStyle: this.brushCellStyle(this.state.brushSize >= 4, 'plus'),
        onMouseDown: this.onMouseDown, onMouseMove: this.onMouseMove, onMouseUp: this.onMouseUp,
        onCanvasDblClick: this.onCanvasDblClick,
        onCanvasContext: this.onCanvasContext,
        showFrameStrip: !this.state.duo,
        showPlay: !this.state.duo,
        playing: !!this.state.playing,
        notPlaying: !this.state.playing,
        togglePlay: this.togglePlay,
        stopPlay: this.stopPlay,
        playTitle: this.animOn()
          ? (this.state.playing ? 'Stop met afspelen (spatie)' : 'Speel je beelden af in het doek (spatie)')
          : 'Zet eerst een tweede beeld aan',
        playBtnStyle: {
          width: this.frameSide() + 'px', height: this.frameSide() + 'px', padding: 0, boxSizing: 'border-box',
          borderRadius: Math.round(this.frameSide() * 0.23) + 'px', flex: '0 0 auto',
          background: this.state.playing ? 'var(--geel)' : 'var(--paars)',
          color: this.state.playing ? 'var(--ink)' : '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          ...this.pressFx('play')
        },
        playOff: !this.animOn(),
        frameTiles: (() => {
          // Tijdens het slepen blijft de rij staan. Pas als je loslaat glijden de
          // beeldjes van hun oude plek naar hun nieuwe.
          const flip = this.flipShift || {};
          const instant = !!this.flipInstant;
          const anim = !!this.flipAnim;
          return this.framesArr().map((art, i) => {
          const live = this.onArr()[i];
          const cur = live && i === (this.state.frameIdx || 0);
          const dragging = this.state.dragFrame === i;
          const dropHere = this.state.dragOver === i && this.state.dragFrame != null && this.state.dragFrame !== i;
          const dx = flip[i] || 0;
          return {
            src: art || BLANK_PNG,
            draggable: live,
            onDragStart: this.onFrameDragStart(i),
            onDragOver: this.onFrameDragOver(i),
            onDragLeave: this.onFrameDragLeave(i),
            onDrop: this.onFrameDrop(i),
            onDragEnd: this.onFrameDragEnd,
            title: cur && i > 0 ? 'Beeld ' + (i + 1) + ' uitzetten' : (live ? 'Beeld ' + (i + 1) + ' — sleep om te verschuiven' : 'Beeld ' + (i + 1) + ' aanzetten'),
            onClick: () => {
              this.stopPlay();
              // Klikken brengt je naar een beeld. Sta je er al op, dan zet de
              // volgende klik het uit. Beeld 1 blijft altijd staan.
              if (!live) this.toggleFrame(i);
              else if (cur && i > 0) this.toggleFrame(i);
              else this.goFrame(i);
            },
            style: {
              // Geen eigen schaduw of transform: dan houdt de knop zijn animatie.
              position: 'relative', flex: '0 0 auto',
              width: this.frameSide() + 'px', height: this.frameSide() + 'px',
              padding: 0, boxSizing: 'border-box', borderRadius: Math.round(this.frameSide() * 0.23) + 'px', background: '#fff',
              borderStyle: 'solid',
              borderColor: (dragging || dropHere) ? 'var(--paars)' : (cur ? 'var(--paars)' : (live ? 'var(--ink)' : 'var(--tekst-3)')),
              boxShadow: dropHere ? '4px 4px 0 var(--paars)' : (dragging ? '2px 2px 0 var(--paars)' : (live ? '3px 3px 0 var(--ink)' : 'none')),
              opacity: dragging ? 0.55 : 1,
              zIndex: dx ? 3 : 1,
              // Alleen tijdens het verhuizen een eigen transform; in rust houdt
              // de knop zo zijn gewone hover- en klikanimatie.
              ...(dx || instant || anim ? {
                transform: 'translateX(' + dx + 'px)',
                transition: instant ? 'none' : 'transform .22s cubic-bezier(.33,1.15,.5,1)'
              } : {}),
              cursor: live ? 'grab' : 'pointer'
            },
            imgStyle: {
              position: 'absolute', left: '2px', top: '2px',
              width: 'calc(100% - 4px)', height: 'calc(100% - 4px)',
              imageRendering: 'pixelated', borderRadius: '8px', display: 'block',
              pointerEvents: 'none', opacity: live ? 1 : 0.28
            }
          };
          });
        })(),
        playRef: this.playRef,
        copySel: this.copySel,
        pasteClip: this.pasteClip,
        showOnion: this.animOn() && !!this.onionArt(),
        onionSrc: this.onionArt() || '',
        onNew: this.onNew, onPublish: this.onPublish,
        incBrush: this.incBrush, decBrush: this.decBrush,
        selectPencil: this.selectPencil, selectEraser: this.selectEraser, selectFill: this.selectFill, selectSpray: this.selectSpray,
        selectSelect: this.selectSelect,
        tipEnter: {
          pencil: this.tipEnter('pencil'), pen: this.tipEnter('pen'), spray: this.tipEnter('spray'),
          fill: this.tipEnter('fill'), eraser: this.tipEnter('eraser'), select: this.tipEnter('select'),
          hulp: this.tipEnter('hulp')
        },
        tipLeave: this.tipLeave,
        // Alleen nog de ballon die je zelf oproept door een gereedschap aan te
        // wijzen. De coachtip die uit zichzelf opdook is weg; daarmee vervielen ook
        // het NIEUW-vlaggetje en de knop "Ik snap het!" die erbij hoorden.
        ...(() => {
          const hv = this.state.hoverTip;
          const t = hv && this.toolTips[hv.id] ? Object.assign({ at: hv.at }, this.toolTips[hv.id]) : null;
          if (!t) return { showTip: false, showTipKey: false, tipTitle: '', tipText: '', tipKey: '', tipStyle: { display: 'none' } };
          return {
            showTip: true,
            showTipKey: !!t.key,
            tipTitle: t.title,
            tipText: t.text,
            tipKey: t.key || '',
            tipStyle: {
              position: 'fixed', left: t.at.x + 'px', top: t.at.y + 'px', transform: 'translateY(-50%)',
              // Boven het tekenvenster. Stond op 70, en het venster ligt op 91: het
              // ballonnetje verscheen wel maar je zag het niet, want het hangt naast
              // de gereedschapskolom en die zit ín dat venster.
              width: '270px', maxWidth: 'calc(100vw - 140px)', zIndex: Z_LAAG, pointerEvents: 'none',
              background: 'var(--paars)', color: '#fff', border: '3px solid var(--ink)', borderRadius: '16px',
              boxShadow: '5px 5px 0 var(--ink)', padding: '14px 16px',
              display: 'flex', flexDirection: 'column', gap: '9px'
            }
          };
        })(),
        showSel: this.isSelectTool(this.state.tool) && !!(this.state.lassoPts || this.state.sel),
        selSvgStyle: {
          position: 'absolute', left: 0, top: 0, width: this.state.canvasPx + 'px', height: this.state.canvasPxH + 'px',
          pointerEvents: 'none', zIndex: 4
        },
        selViewBox: '0 0 ' + GW + ' ' + GH,
        // De rand loopt langs de cellenrand, niet door de celmiddens: zo valt de
        // selectie precies samen met de pixels die je verplaatst.
        selPathD: (() => {
          const s = this.state.sel || (this.state.lassoPts ? (this.state.tool === 'marquee' ? this.rectToSel(this.state.lassoPts) : this.lassoToSel(this.state.lassoPts)) : null);
          if (!s) return '';
          const on = (cx, cy) => {
            if (cx < 0 || cy < 0 || cx >= s.w || cy >= s.h) return false;
            return s.mask ? !!s.mask[cy * s.w + cx] : true;
          };
          const seg = [];
          for (let cy = 0; cy < s.h; cy++) {
            for (let cx = 0; cx < s.w; cx++) {
              if (!on(cx, cy)) continue;
              const gx = s.x + cx, gy = s.y + cy;
              if (!on(cx, cy - 1)) seg.push('M' + gx + ' ' + gy + 'h1');
              if (!on(cx, cy + 1)) seg.push('M' + gx + ' ' + (gy + 1) + 'h1');
              if (!on(cx - 1, cy)) seg.push('M' + gx + ' ' + gy + 'v1');
              if (!on(cx + 1, cy)) seg.push('M' + (gx + 1) + ' ' + gy + 'v1');
            }
          }
          return seg.join('');
        })(),
        selFillD: (() => {
          const s = this.state.sel || (this.state.lassoPts ? (this.state.tool === 'marquee' ? this.rectToSel(this.state.lassoPts) : this.lassoToSel(this.state.lassoPts)) : null);
          if (!s) return '';
          const out = [];
          for (let cy = 0; cy < s.h; cy++) {
            for (let cx = 0; cx < s.w; cx++) {
              const hit = s.mask ? s.mask[cy * s.w + cx] : 1;
              if (hit) out.push('M' + (s.x + cx) + ' ' + (s.y + cy) + 'h1v1h-1z');
            }
          }
          return out.join('');
        })(),
  
        wallRef: this.wallRef,
        dropRef: this.dropRef,
        // Een gestippelde leegte, zoals CLAUDE.md die voorschrijft: 3px in var(--rand-stippel).
        dropSlotStyle: {
          position: 'absolute', display: 'none', pointerEvents: 'none', zIndex: 0,
          width: NOTE_W + 'px', height: NOTE_H + 'px',
          marginLeft: -(NOTE_W / 2) + 'px',
          border: '3px dashed var(--rand-stippel)', borderRadius: '12px', boxSizing: 'border-box'
        },
        poleStyle: {
          position: 'absolute', top: '0', bottom: '0',
          left: this.paalMiddenCss(), transform: 'translateX(-50%)',
          width: poleWidth(wall.lanes) + 'px', zIndex: '0', pointerEvents: 'none',
          background: POLE_BG,
          boxShadow: 'inset 40px 0 40px -40px rgba(30,26,48,.35),inset -40px 0 40px -40px rgba(30,26,48,.35)'
        },
        wallStyle: { position: 'relative', width: '100%', height: wall.height + 'px' },
        wallArranged: this.wallIsArranged(),
        resetWall: this.resetWall,
        galleryItems: this.state.galleryItems.map((g) => {
          const hovered = this.state.hoveredId === g.id;
          return {
            ...g,
            // Wat een schermlezer voorleest in plaats van de krabbel zelf.
            alt: 'Krabbel “' + (g.title || 'zonder titel') + '” van ' + (nameOf(g) || g.author || 'iemand'),
            author: g.coAuthorId && accountById[g.coAuthorId] ? nameOf(g) + ' & ' + accountById[g.coAuthorId].name : nameOf(g),
            // Bij hover wipt de krabbel als geheel op: 20% groter en een klein
            // zwiepje extra, per krabbel een andere kant op. Telbolletje en
            // NIEUW-rand schalen zo automatisch mee.
            noteStyle: (() => {
              const str = String(g.id || '');
              let h = 0;
              for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) % 997;
              const tilt = (h % 9) - 4 + (h % 2 ? 0.5 : -0.5);
              const pop = hovered ? ' scale(1.2)' : '';
              // g.rot loopt van -4 tot +4 graden. Anderhalf keer zoveel maakt er
              // -6 tot +6 van: duidelijk scheef opgeplakt, maar nog steeds binnen
              // de lucht tussen de treden, dus niets gaat elkaar raken.
              const rot = (g.rot * 1.5) / (isWide(g) ? 2 : 1) + (hovered ? tilt : 0);
              const spot = wall.spots.get(g.id) || { x: 0, y: 0 };
              const breed = isWide(g) ? 216 : 104;
              // Heb je deze krabbel op dit moment vast? Dan hoort hij onder je muis
              // te blijven, ook als de app zichzelf ondertussen hertekent.
              const sleep = this.dragNote && this.dragNote.id === g.id && this.dragNote.gesleept
                ? this.dragNote
                : null;
              const px = sleep ? sleep.x : spot.x;
              const py = sleep ? sleep.y : spot.y;
              return {
                // Elke krabbel hangt op zijn eigen plek aan de paal. `left` rekent
                // vanaf het hart van de paal, dus 0 is precies in het midden.
                position: 'absolute',
                left: `calc(${this.paalMiddenCss()} + ${Math.round(px)}px)`,
                top: Math.round(py) + 'px',
                marginLeft: -(breed / 2) + 'px',
                width: breed + 'px',
                cursor: this.state.isMobile ? 'pointer' : 'grab',
                // Zelf opgehangen krabbels liggen boven de standaardstand.
                // Nieuwere krabbels liggen altijd over oudere heen. De lijst staat
                // op nieuwste eerst, dus hoe lager de index, hoe hoger hij ligt.
                // Zonder dit besliste de volgorde in de DOM het, en dan lag de
                // nieuwste er juist onder.
                zIndex: sleep ? 100000 : (hovered ? 99999 : Math.max(1, aantalKrabbels - g.index)),
                transformOrigin: '50% 55%',
                transform: `rotate(${rot}deg)` + pop,
                // Naar zijn vakje glijden in plaats van erheen springen. Zo zie je
                // ook dat de krabbel die ervoor hing naar jouw oude plek verhuist.
                transition: 'left .2s cubic-bezier(.22,1,.36,1), top .2s cubic-bezier(.22,1,.36,1), transform .12s cubic-bezier(.34,1.5,.64,1)'
              };
            })(),
            noteRef: this.noteRef(g.id),
            onNoteDown: (e) => this.onNoteDown(g, wall.spots.get(g.id) || { x: 0, y: 0, step: 0 }, e),
            hovered,
            onEnter: () => { clearTimeout(this.touchHeartT); this.setState({ hoveredId: g.id }); },
            onLeave: () => { this.setState((st) => (st.hoveredId === g.id ? { hoveredId: null } : null)); },
            // Tikken toont de titel. Bewegen is scrollen, niet tikken: dan weer weg.
            // Belangrijk dat dit tijdens het scrollen géén setState doet, anders
            // hertekent de hele paal bij elke vingerbeweging en gaat het haperen.
            onTouch: (e) => {
              if (!mob) return;
              const t = e && e.touches && e.touches[0];
              this.touchPt = t ? { x: t.clientX, y: t.clientY } : null;
              if (this.state.hoveredId === g.id) return;
              clearTimeout(this.touchHeartT);
              this.setState({ hoveredId: g.id });
              this.touchHeartT = setTimeout(() => {
                this.setState((st) => (st.hoveredId === g.id ? { hoveredId: null } : null));
              }, 1600);
            },
            onTouchMove: (e) => {
              if (!mob || !this.touchPt) return;
              const t = e && e.touches && e.touches[0];
              if (!t) return;
              const dx = t.clientX - this.touchPt.x, dy = t.clientY - this.touchPt.y;
              if (dx * dx + dy * dy < 100) return;
              this.touchPt = null;
              clearTimeout(this.touchHeartT);
              this.setState((st) => (st.hoveredId === g.id ? { hoveredId: null } : null));
            },
            isRequested: !!reqByDrawing[g.id],
            isThemeMatch: !!g.isThemeMatch,
            themeLabel: (() => {
              const t = g.themeText || this.themeForDate(g.created);
              return t ? 'Thema: ' + t : 'Thema';
            })(),
            requestLabel: (() => {
              const r = reqByDrawing[g.id];
              if (!r) return '';
              const f = accountById[r.fromId];
              return 'Verzoekje van ' + (f ? f.name : 'iemand');
            })(),
            showInfo: hovered && !mob,
            infoStyle: {
              position: 'absolute', left: '114%', top: '50%', transform: 'translateY(-50%)',
              background: '#fff', border: '3px solid var(--ink)', borderRadius: '12px', boxShadow: '3px 3px 0 var(--ink)',
              padding: '7px 11px', whiteSpace: 'nowrap', zIndex: 30, pointerEvents: 'none', fontSize: '13px',
              // Het venstertje wacht even, zodat het niet meteen opduikt als je
              // met je muis over de paal glijdt.
              transformOrigin: '0% 50%',
              animation: 'gpInfoIn .19s cubic-bezier(.34,1.56,.64,1) .15s both'
            },
            onImgLoad: (e) => {
              const im = e.target;
              if (im.naturalWidth > im.naturalHeight * 1.4 && !this.state.wideIds[g.id]) {
                this.setState((st) => ({ wideIds: { ...st.wideIds, [g.id]: true } }));
              }
            },
            isAnim: g.frames > 1,
            isStatic: !(g.frames > 1),
            imgStyle: {
              width: '100%', aspectRatio: isWide(g) ? '2/1' : '1/1', imageRendering: 'pixelated',
              display: 'block', background: '#fff', boxShadow: '0 6px 12px rgba(0,0,0,.28)', cursor: 'pointer'
            },
            // Alle beelden in één strook: de achtergrond verspringt stap voor
            // stap naar rechts, dus er is maar één plaatje nodig.
            animStyle: (() => {
              const n = Math.max(2, Math.min(MAX_FRAMES, Number(g.frames) || 2));
              return {
                width: '100%', aspectRatio: '1/1', imageRendering: 'pixelated',
                display: 'block', background: '#fff', boxShadow: '0 6px 12px rgba(0,0,0,.28)', cursor: 'pointer',
                backgroundImage: 'url(' + g.src + ')', backgroundSize: (n * 100) + '% 100%', backgroundRepeat: 'no-repeat',
                animation: 'gp-f' + n + ' ' + animDur(n) + 's step-end infinite'
              };
            })(),
            showLikeCount: g.likesCount > 0,
            likeCountStyle: {
              position: 'absolute', bottom: '-10px', right: '-10px', height: '21px',
              borderRadius: '12px', border: '3px solid var(--ink)', background: '#fff', color: 'var(--ink)',
              fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '3px',
              padding: '0 7px', boxShadow: '2px 2px 0 var(--ink)'
            },
            onOpen: () => this.openViewer(g.id),
            commentCount: ((this.state.comments || {})[g.id] || []).length,
            hasComments: ((this.state.comments || {})[g.id] || []).length > 0,
            showCountBubble: g.likesCount > 0 || ((this.state.comments || {})[g.id] || []).length > 0,
            showBothCounts: g.likesCount > 0 && ((this.state.comments || {})[g.id] || []).length > 0,
            isNew: (() => { const t = parseTs(g.created); return !isNaN(t) && now - t < 600000; })(),
            newStyle: {
              position: 'absolute', inset: '-7px', zIndex: 12, pointerEvents: 'none',
              border: '3px solid var(--groen)', borderRadius: '8px',
              animation: 'freshPulse 2.5s cubic-bezier(.4,1.35,.5,1) forwards'
            },
          };
        }),
        hasItems: this.state.galleryItems.length > 0,
        galleryEmpty: connected && !this.state.galleryLoading && this.state.galleryItems.length === 0,
        emptyTitle: this.state.galleryError ? 'Er ging iets mis' : 'Nog niks hier',
        emptyBody: this.state.galleryError ? this.state.galleryError : 'Publiceer je eerste tekening vanuit de Studio!',
  
        showPublish: this.state.dialog === 'publish',
        closeDialog: this.closeDialog,
        stopProp: this.stopProp,
        showLogoutConfirm: !!this.state.logoutConfirm,
        cancelLogout: this.cancelLogout,
        logout: this.logout,
        publishTitle: this.state.publishTitle,
        publishIsTheme: this.state.publishIsTheme,
        onTitleInput: this.onTitleInput,
        toggleThemeMatch: this.toggleThemeMatch,
        themeBtnStyle: this.state.publishIsTheme
          ? { background: 'var(--geel-vlak)', boxShadow: '3px 3px 0 var(--ink)' }
          : { background: '#fff' },
        themeBoxStyle: {
          width: 28, height: 28, borderRadius: 8, border: '3px solid var(--ink)', flex: '0 0 auto',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: this.state.publishIsTheme ? 'var(--geel)' : '#fff',
          transition: 'background .15s ease'
        },
        themeCheckStyle: {
          strokeDasharray: 24, strokeDashoffset: this.state.publishIsTheme ? 0 : 24,
          opacity: this.state.publishIsTheme ? 1 : 0,
          transition: 'stroke-dashoffset .25s ease, opacity .15s ease'
        },
        doPublish: this.doPublish,
        publishing: this.state.publishing,
        publishBtnLabel: this.state.publishing ? 'Plakken…' : 'Plakken',
        hasPublishError: !!this.state.publishError,
        publishError: this.state.publishError,
  
        toggleChat: this.toggleChat,
        chatOpen: this.state.chatOpen,
        showChat: this.chatVisible(),
        showChatClose: true,
        chatPanelStyle: mob
          ? {
              animation: this.state.buzzing ? 'gpBuzz .42s ease-in-out 2' : 'none',
              position: 'fixed', inset: '10px',
              background: '#fff', border: '4px solid var(--ink)', borderRadius: '16px',
              boxShadow: '0 0 0 100vmax var(--ink)', display: 'flex', flexDirection: 'column',
              // Op de telefoon is de chat schermvullend, dus hoort hij bij de laag van
              // de schermvullende vensters en niet bij de vensterstapel eronder.
              zIndex: Z_LAAG, overflow: 'hidden', overscrollBehavior: 'contain'
            }
          : Object.assign({
              animation: this.state.buzzing ? 'gpBuzz .42s ease-in-out 2' : 'none',
              position: 'fixed', width: CHAT_W + 'px', height: 'min(560px,calc(100vh - ' + (TASKBAR_H + 130) + 'px))',
              background: '#fff', border: '3px solid var(--ink)', borderRadius: '16px',
              /**
               * De chat doet mee in de stapelorde van de vensters.
               *
               * Hij stond op 60 en lag daarmee altijd onder de programmaatjes, en dat
               * kon toen tekenen nog een heel scherm was. Nu is het een venster tussen
               * de vensters: klik je erin, dan komt hij bovenop. Zijn eigen witte
               * uiterlijk houdt hij; alleen de hoogte komt uit de laag.
               */
              boxShadow: (this.vensterVoorop() === 'chat' ? '6px 6px 0 ' : '3px 3px 0 ') + 'var(--ink)',
              display: 'flex', flexDirection: 'column',
              zIndex: this.vensterZ('chat'), overflow: 'hidden'
            }, this.vensterPlekVan('chat')
              ? { left: this.vensterPlekVan('chat').x + 'px', top: this.vensterPlekVan('chat').y + 'px' }
              // Standaard staat hij rechtsonder, vlak boven zijn eigen knop in de
              // taakbalk. Daar komt hij vandaan, dus daar hoort hij op te komen.
              // Niet in het midden zoals de andere vensters: dit is het enige venster
              // met een vaste hoek, en daarom gebruikt hij `vensterStaStyle` niet.
              // Rechts op dezelfde lijn als het systeemvak eronder: de taakbalk heeft
              // zestien pixels padding rechts, en de klok eindigt daar. Hier stond 22, en
              // dan lijnde het venster met niets uit.
              : { bottom: (TASKBAR_H + 14) + 'px', right: '16px' }),
        chatNaarVoren: () => this.vensterNaarVoren('chat'),
        // Slepen komt uit de vensterlaag; de chat had er zijn eigen kopie van.
        chatSleepAan: (e) => this.vensterSleepAan('chat', e),
        chatSleep: this.vensterSleep,
        chatSleepUit: this.vensterSleepUit,
        chatHeaderStyle: {
          flex: '0 0 auto', padding: '0 16px', minHeight: '56px', boxSizing: 'border-box', background: 'var(--roze-balk)',
          borderBottom: '3px solid var(--ink)', fontWeight: '700', fontSize: mq('22px', '20px'),
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          cursor: mq('default', 'grab'), userSelect: 'none'
        },
        notifDropdownStyle: mob
          ? { position: 'fixed', inset: '10px', zIndex: Z_LAAG, overflow: 'hidden', overscrollBehavior: 'contain', background: '#fff', border: '4px solid var(--ink)', borderRadius: '16px', boxShadow: '0 0 0 100vmax var(--ink)', display: 'flex', flexDirection: 'column' }
          // Geen binnenruimte en geen scroll op het paneel zelf: de roze kop moet
          // blijven staan en alleen de lijst eronder mag schuiven, net als bij de
          // chat. Vandaar overflow hidden hier en het scrollen een laag lager.
          // Dezelfde maat als het chatvenster: 360 breed en dezelfde hoogte met
          // dezelfde bovengrens. Dit paneel groeide eerst mee met de inhoud en werd
          // dan 773 hoog, bijna twee keer de chat, terwijl ze naast elkaar uit
          // dezelfde balk komen.
          : { position: 'fixed', bottom: (TASKBAR_H + 14) + 'px', right: '16px', zIndex: 71, width: CHAT_W + 'px', height: 'min(560px,calc(100vh - ' + (TASKBAR_H + 130) + 'px))', overflow: 'hidden', background: '#fff', border: '3px solid var(--ink)', borderRadius: '16px', boxShadow: '6px 6px 0 var(--ink)', display: 'flex', flexDirection: 'column' },
        chatInputRowStyle: {
          flex: '0 0 auto', display: 'flex', gap: '8px', alignItems: 'center',
          borderTop: '3px solid var(--ink)', padding: '10px'
        },
        chatScrollRef: this.chatScrollRef,
        chatScrollStyle: { flex: '1 1 auto', overflowY: 'auto', overscrollBehavior: 'contain', padding: mq('14px', '12px'), display: mentions.length > 0 ? 'none' : 'flex', flexDirection: 'column', gap: mq('12px', '8px') },
        chatEmptyStyle: { margin: 'auto', textAlign: 'center', color: 'var(--tekst-3)', fontSize: mq('15px', '13px') },
        chatAvatarEmptyStyle: (() => { const n = mq(26, 20); return { width: n + 'px', height: n + 'px', flex: '0 0 auto', border: '2px dashed var(--ink)', borderRadius: '8px', background: 'var(--lila)' }; })(),
        chatAvatarStyle: (() => { const n = mq(26, 20); return { width: n + 'px', height: n + 'px', imageRendering: 'pixelated', border: '2px solid var(--ink)', borderRadius: '8px', background: '#fff', display: 'block' }; })(),
        chatDayStyle: { alignSelf: 'center', fontSize: '11px', fontWeight: 700, color: 'var(--tekst-3)', letterSpacing: '.05em', textTransform: 'uppercase', margin: '6px 0 8px' },
        chatEmpty: this.state.chatMessages.length === 0,
        chatMessages: this.state.chatMessages.map((m, mi) => {
          const acc = accOf(m);
          const displayName = acc ? acc.name : m.author;
          const mine = m.accountId ? m.accountId === this.state.accountId : m.author === this.state.author;
          const t = parseTs(m.created);
          const dt = isNaN(t) ? null : new Date(t);
          const prev = this.state.chatMessages[mi - 1];
          const pt = prev ? parseTs(prev.created) : NaN;
          const pd = isNaN(pt) ? null : new Date(pt);
          const sameDay = dt && pd && dt.toDateString() === pd.toDateString();
          const today = new Date(); const yest = new Date(Date.now() - 86400000);
          let dayLabel = '';
          if (dt) {
            if (dt.toDateString() === today.toDateString()) dayLabel = 'vandaag';
            else if (dt.toDateString() === yest.toDateString()) dayLabel = 'gisteren';
            else dayLabel = dt.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' });
          }
          return {
            ...m,
            author: displayName,
            showDay: !!dt && !sameDay,
            dayLabel,
            time: dt ? dt.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }) : '',
            isBuzz: isBuzzText(m.text),
            buzzAvatarStyle: { width: '30px', height: '30px', imageRendering: 'pixelated', border: '3px solid var(--ink)', borderRadius: '8px', background: '#fff', display: 'block', flex: '0 0 auto' },
            hasAvatar: !isBuzzText(m.text) && (!!(mine ? myAvatar : ((acc && acc.avatar) || avatarByName[m.author]) && ((acc && acc.avatar) || avatarByName[m.author]).length === AV * AV) || !!DEFAULT_AV),
            noAvatar: !isBuzzText(m.text) && !(mine ? myAvatar : ((acc && acc.avatar) || avatarByName[m.author]) && ((acc && acc.avatar) || avatarByName[m.author]).length === AV * AV) && !DEFAULT_AV,
            avatarUrl: avatarUrl(mine ? myAvatar : ((acc && acc.avatar) || avatarByName[m.author])),
            rowStyle: isBuzzText(m.text) ? {
              display: 'flex', justifyContent: 'center', alignSelf: 'center', width: '100%', padding: '7px 18px', boxSizing: 'border-box'
            } : {
              display: 'flex', flexDirection: mine ? 'row-reverse' : 'row',
              alignItems: 'flex-end', gap: mq('8px', '6px'), maxWidth: '86%',
              alignSelf: mine ? 'flex-end' : 'flex-start'
            },
            authorStyle: isBuzzText(m.text) ? { display: 'none' } : {
              fontSize: mq('13px', '12px'), fontWeight: 600, lineHeight: 1.2,
              marginBottom: '2px', color: mine ? 'rgba(255,255,255,.82)' : 'var(--tekst-2)'
            },
            textStyle: isBuzzText(m.text)
              ? { fontSize: '14px', fontWeight: 700, fontStyle: 'italic', letterSpacing: '.02em', lineHeight: 1.2, color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }
              : {
                  fontSize: isSingleEmoji(m.text) ? (mq('45px', '42px')) : (mq('16px', '14px')),
                  lineHeight: isSingleEmoji(m.text) ? 1.05 : 1.35, wordBreak: 'break-word', overflowWrap: 'anywhere'
                },
            parts: mentionSplit(m.text, this.mentionNames, (this.state.author || '').toLowerCase()).map((p) => ({
              t: p.t,
              style: p.mention && !isBuzzText(m.text)
                ? {
                    fontWeight: 700, borderRadius: '8px', padding: '0 4px', whiteSpace: 'nowrap',
                    background: p.me ? 'var(--geel)' : (mine ? 'rgba(255,255,255,.22)' : 'var(--lila-diep)'),
                    color: p.me ? 'var(--ink)' : (mine ? '#fff' : 'var(--paars-donker)')
                  }
                : {}
            })),
            bubbleStyle: isBuzzText(m.text) ? {
              background: 'var(--geel)', color: 'var(--ink)', clipPath: BUZZ_CLIP, border: 'none', borderRadius: '0',
              width: '100%', height: BUZZ_H + 'px', boxSizing: 'border-box',
              padding: '6px 20px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
              gap: '10px', textAlign: 'center', overflow: 'hidden'
            } : {
              background: mine ? 'var(--paars)' : 'var(--lila)', color: mine ? '#fff' : 'var(--ink)',
              border: '3px solid var(--ink)', borderRadius: '12px',
              padding: mq('8px 12px', '7px 11px'),
              display: 'flex', flexDirection: 'column', minWidth: '0',
              wordBreak: 'break-word', boxShadow: '2px 2px 0 var(--ink)'
            }
          };
        }),
        showMentionList: mentions.length > 0,
        mentionListTitle: this.state.buzzPick ? 'Wie wil je buzzen?' : 'Wie bedoel je?',
        mentionOptions: mentions.map((a) => ({
          name: a.name, avatarUrl: avatarUrl(a.avatar),
          onPick: () => (this.state.buzzPick ? this.sendBuzz(a.name) : this.pickMention(a.name))
        })),
        ...this.pollVals(),
        ...this.commentVals(viewer),
        ...this.desktopVals(),
        ...this.snakeVals(),
        ...this.memVals(),
        ...this.tamVals(),
        ...this.ketVals(),
        ...this.arcadeVals(),
        ...this.beestjeVals(),
        ...this.arenaVals(),
        sendBuzz: this.startBuzz,
        buzzDisabled: !!this.state.chatSending,
        buzzTitle: 'Buzz iemand: kies daarna een naam',
        buzzBtnStyle: {
          flex: '0 0 auto', height: '44px', width: '44px', padding: '0', justifyContent: 'center', borderRadius: '12px',
          background: 'var(--geel)', color: 'var(--ink)'
        },
        chatInput: this.state.chatInput,
        onChatInput: this.onChatInput,
        onChatKey: this.onChatKey,
        sendChat: this.sendChat,
        chatSending: this.state.chatSending
      };
    }
};
